"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _AppApisV1AwaitingDeliveryOrdersListAwaitingDeliveryOrders200Response = _interopRequireDefault(require("../model/AppApisV1AwaitingDeliveryOrdersListAwaitingDeliveryOrders200Response"));

var _AppApisV1AwaitingValidationOrdersListAwaitingValidationOrders200Response = _interopRequireDefault(require("../model/AppApisV1AwaitingValidationOrdersListAwaitingValidationOrders200Response"));

var _AppApisV1DeliveredOrdersListDeliveredOrders200Response = _interopRequireDefault(require("../model/AppApisV1DeliveredOrdersListDeliveredOrders200Response"));

var _AppApisV1DraftedOrdersListDraftedOrders200Response = _interopRequireDefault(require("../model/AppApisV1DraftedOrdersListDraftedOrders200Response"));

var _AppApisV1PurchaseOrdersListPurchaseOrders200Response = _interopRequireDefault(require("../model/AppApisV1PurchaseOrdersListPurchaseOrders200Response"));

var _AppApisV1ValidatedOrdersListValidatedOrders200Response = _interopRequireDefault(require("../model/AppApisV1ValidatedOrdersListValidatedOrders200Response"));

var _AwaitingDeliveryDeliverRequest = _interopRequireDefault(require("../model/AwaitingDeliveryDeliverRequest"));

var _AwaitingDeliveryOrderSchema = _interopRequireDefault(require("../model/AwaitingDeliveryOrderSchema"));

var _AwaitingDeliveryProductSchema = _interopRequireDefault(require("../model/AwaitingDeliveryProductSchema"));

var _AwaitingDeliveryProductUpdateRequest = _interopRequireDefault(require("../model/AwaitingDeliveryProductUpdateRequest"));

var _AwaitingDeliveryUpdateRequest = _interopRequireDefault(require("../model/AwaitingDeliveryUpdateRequest"));

var _AwaitingValidationAction = _interopRequireDefault(require("../model/AwaitingValidationAction"));

var _AwaitingValidationOrderSchema = _interopRequireDefault(require("../model/AwaitingValidationOrderSchema"));

var _AwaitingValidationOrderUpdateQuantitiesRequestInner = _interopRequireDefault(require("../model/AwaitingValidationOrderUpdateQuantitiesRequestInner"));

var _AwaitingValidationProductSchema = _interopRequireDefault(require("../model/AwaitingValidationProductSchema"));

var _AwaitingValidationProductUpdateRequest = _interopRequireDefault(require("../model/AwaitingValidationProductUpdateRequest"));

var _AwaitingValidationUpdateRequest = _interopRequireDefault(require("../model/AwaitingValidationUpdateRequest"));

var _CompletionStatusEnum = _interopRequireDefault(require("../model/CompletionStatusEnum"));

var _Deliver = _interopRequireDefault(require("../model/Deliver"));

var _DeliveredOrderSchema = _interopRequireDefault(require("../model/DeliveredOrderSchema"));

var _DeliveredOrderUpdateRequest = _interopRequireDefault(require("../model/DeliveredOrderUpdateRequest"));

var _DeliveredProductPriceUpdateRequest = _interopRequireDefault(require("../model/DeliveredProductPriceUpdateRequest"));

var _DeliveredProductSchema = _interopRequireDefault(require("../model/DeliveredProductSchema"));

var _DeliveredProductUpdateRequest = _interopRequireDefault(require("../model/DeliveredProductUpdateRequest"));

var _DraftedSuggestedOrderCreationRequest = _interopRequireDefault(require("../model/DraftedSuggestedOrderCreationRequest"));

var _DraftedSuggestedOrderSchema = _interopRequireDefault(require("../model/DraftedSuggestedOrderSchema"));

var _DraftedSuggestedOrderUpdateRequest = _interopRequireDefault(require("../model/DraftedSuggestedOrderUpdateRequest"));

var _DraftedSuggestedOrdersGenerationRequest = _interopRequireDefault(require("../model/DraftedSuggestedOrdersGenerationRequest"));

var _DraftedSuggestedProductCreationRequest = _interopRequireDefault(require("../model/DraftedSuggestedProductCreationRequest"));

var _DraftedSuggestedProductSchema = _interopRequireDefault(require("../model/DraftedSuggestedProductSchema"));

var _DraftedSuggestedProductUpdateRequest = _interopRequireDefault(require("../model/DraftedSuggestedProductUpdateRequest"));

var _Errors = _interopRequireDefault(require("../model/Errors"));

var _ExportRequest = _interopRequireDefault(require("../model/ExportRequest"));

var _Job = _interopRequireDefault(require("../model/Job"));

var _JobList = _interopRequireDefault(require("../model/JobList"));

var _JobUpdateRequest = _interopRequireDefault(require("../model/JobUpdateRequest"));

var _ProductOrderCreationRequest = _interopRequireDefault(require("../model/ProductOrderCreationRequest"));

var _ProductOrderSchema = _interopRequireDefault(require("../model/ProductOrderSchema"));

var _ProductOrderUpdateRequest = _interopRequireDefault(require("../model/ProductOrderUpdateRequest"));

var _PurchaseOrderCheckRequest = _interopRequireDefault(require("../model/PurchaseOrderCheckRequest"));

var _PurchaseOrderCreationRequest = _interopRequireDefault(require("../model/PurchaseOrderCreationRequest"));

var _PurchaseOrderHistoryRequest = _interopRequireDefault(require("../model/PurchaseOrderHistoryRequest"));

var _PurchaseOrderSchema = _interopRequireDefault(require("../model/PurchaseOrderSchema"));

var _PurchaseOrderUpdateRequest = _interopRequireDefault(require("../model/PurchaseOrderUpdateRequest"));

var _RunPurchaseJobSchema = _interopRequireDefault(require("../model/RunPurchaseJobSchema"));

var _StatusEnum = _interopRequireDefault(require("../model/StatusEnum"));

var _SubmitPurchaseJobOutputSchema = _interopRequireDefault(require("../model/SubmitPurchaseJobOutputSchema"));

var _SubstituteCreationRequest = _interopRequireDefault(require("../model/SubstituteCreationRequest"));

var _Task = _interopRequireDefault(require("../model/Task"));

var _TaskList = _interopRequireDefault(require("../model/TaskList"));

var _TriggeredShippingPolicy = _interopRequireDefault(require("../model/TriggeredShippingPolicy"));

var _UpdatePurchaseOrderDeliveryChargesRequest = _interopRequireDefault(require("../model/UpdatePurchaseOrderDeliveryChargesRequest"));

var _ValidatePurchaseOrderRequest = _interopRequireDefault(require("../model/ValidatePurchaseOrderRequest"));

var _ValidatedOrderCancelRequest = _interopRequireDefault(require("../model/ValidatedOrderCancelRequest"));

var _ValidatedOrderCreationRequest = _interopRequireDefault(require("../model/ValidatedOrderCreationRequest"));

var _ValidatedOrderGeneratePDFRequest = _interopRequireDefault(require("../model/ValidatedOrderGeneratePDFRequest"));

var _ValidatedOrderSavePDFRequest = _interopRequireDefault(require("../model/ValidatedOrderSavePDFRequest"));

var _ValidatedOrderSchema = _interopRequireDefault(require("../model/ValidatedOrderSchema"));

var _ValidatedOrderSendMailResultRequest = _interopRequireDefault(require("../model/ValidatedOrderSendMailResultRequest"));

var _ValidatedOrderUpdateRequest = _interopRequireDefault(require("../model/ValidatedOrderUpdateRequest"));

var _ValidatedProductCreationRequest = _interopRequireDefault(require("../model/ValidatedProductCreationRequest"));

var _ValidatedProductSchema = _interopRequireDefault(require("../model/ValidatedProductSchema"));

var _ValidatedProductUpdateRequest = _interopRequireDefault(require("../model/ValidatedProductUpdateRequest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* PurchaseOrders service.
* @module api/PurchaseOrdersApi
* @version 1.126
*/
var PurchaseOrdersApi = /*#__PURE__*/function () {
  /**
  * Constructs a new PurchaseOrdersApi. 
  * @alias module:api/PurchaseOrdersApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function PurchaseOrdersApi(apiClient) {
    _classCallCheck(this, PurchaseOrdersApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Advance the reception of an awaiting delivery purchase order.
   * **scope**: awaiting-delivery-orders:write 
   * @param {String} purchaseOrderUuid 
   * @param {Object} opts Optional parameters
   * @param {Date} opts.receptionDate 
   * @param {Number} opts.days 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */


  _createClass(PurchaseOrdersApi, [{
    key: "appApisV1AwaitingDeliveryOrdersAdvanceAwaitingDeliveryOrderWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersAdvanceAwaitingDeliveryOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersAdvanceAwaitingDeliveryOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'reception_date': opts['receptionDate'],
        'days': opts['days']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/advance', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Advance the reception of an awaiting delivery purchase order.
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.receptionDate 
     * @param {Number} opts.days 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersAdvanceAwaitingDeliveryOrder",
    value: function appApisV1AwaitingDeliveryOrdersAdvanceAwaitingDeliveryOrder(purchaseOrderUuid, opts) {
      return this.appApisV1AwaitingDeliveryOrdersAdvanceAwaitingDeliveryOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Deliver awaiting-delivery orders with validated quantity as default
     * **scope**: awaiting-delivery-orders:admin 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid Location uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersAutoDeliverDeliveryOrdersWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersAutoDeliverDeliveryOrdersWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'location_uuid': opts['locationUuid']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/auto-deliver', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Deliver awaiting-delivery orders with validated quantity as default
     * **scope**: awaiting-delivery-orders:admin 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid Location uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersAutoDeliverDeliveryOrders",
    value: function appApisV1AwaitingDeliveryOrdersAutoDeliverDeliveryOrders(opts) {
      return this.appApisV1AwaitingDeliveryOrdersAutoDeliverDeliveryOrdersWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Cancel the delivery charges of an awaiting delivery purchase order
     * **scope**: awaiting-delivery-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersCancelAwaitingDeliveryOrderDeliveryChargesWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersCancelAwaitingDeliveryOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersCancelAwaitingDeliveryOrderDeliveryCharges");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/cancel-delivery-charges', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Cancel the delivery charges of an awaiting delivery purchase order
     * **scope**: awaiting-delivery-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersCancelAwaitingDeliveryOrderDeliveryCharges",
    value: function appApisV1AwaitingDeliveryOrdersCancelAwaitingDeliveryOrderDeliveryCharges(purchaseOrderUuid) {
      return this.appApisV1AwaitingDeliveryOrdersCancelAwaitingDeliveryOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Add a new product substitute to an awaiting delivery order
     * **scope**: awaiting-delivery-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/SubstituteCreationRequest} substituteCreationRequest The information to use to create the new substitute to the awaiting delivery order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AwaitingDeliveryProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersCreateAwaitingDeliveryProductOrderWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersCreateAwaitingDeliveryProductOrderWithHttpInfo(purchaseOrderUuid, substituteCreationRequest) {
      var postBody = substituteCreationRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersCreateAwaitingDeliveryProductOrder");
      } // verify the required parameter 'substituteCreationRequest' is set


      if (substituteCreationRequest === undefined || substituteCreationRequest === null) {
        throw new Error("Missing the required parameter 'substituteCreationRequest' when calling appApisV1AwaitingDeliveryOrdersCreateAwaitingDeliveryProductOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AwaitingDeliveryProductSchema["default"];
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/products', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Add a new product substitute to an awaiting delivery order
     * **scope**: awaiting-delivery-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/SubstituteCreationRequest} substituteCreationRequest The information to use to create the new substitute to the awaiting delivery order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AwaitingDeliveryProductSchema}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersCreateAwaitingDeliveryProductOrder",
    value: function appApisV1AwaitingDeliveryOrdersCreateAwaitingDeliveryProductOrder(purchaseOrderUuid, substituteCreationRequest) {
      return this.appApisV1AwaitingDeliveryOrdersCreateAwaitingDeliveryProductOrderWithHttpInfo(purchaseOrderUuid, substituteCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delay the reception of an awaiting delivery purchase order.
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.receptionDate 
     * @param {Number} opts.days 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersDelayAwaitingDeliveryOrderWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersDelayAwaitingDeliveryOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersDelayAwaitingDeliveryOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'reception_date': opts['receptionDate'],
        'days': opts['days']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/delay', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delay the reception of an awaiting delivery purchase order.
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.receptionDate 
     * @param {Number} opts.days 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersDelayAwaitingDeliveryOrder",
    value: function appApisV1AwaitingDeliveryOrdersDelayAwaitingDeliveryOrder(purchaseOrderUuid, opts) {
      return this.appApisV1AwaitingDeliveryOrdersDelayAwaitingDeliveryOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete Purchase Orders
     * **scope**: awaiting-delivery-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersDeleteAwaitingDeliveryOrderWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersDeleteAwaitingDeliveryOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersDeleteAwaitingDeliveryOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete Purchase Orders
     * **scope**: awaiting-delivery-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersDeleteAwaitingDeliveryOrder",
    value: function appApisV1AwaitingDeliveryOrdersDeleteAwaitingDeliveryOrder(purchaseOrderUuid) {
      return this.appApisV1AwaitingDeliveryOrdersDeleteAwaitingDeliveryOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get awaiting delivery orders
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AwaitingDeliveryOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersGetAwaitingDeliveryOrderWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersGetAwaitingDeliveryOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersGetAwaitingDeliveryOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'ignore_zero_validated_quantities': opts['ignoreZeroValidatedQuantities']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AwaitingDeliveryOrderSchema["default"];
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get awaiting delivery orders
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AwaitingDeliveryOrderSchema}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersGetAwaitingDeliveryOrder",
    value: function appApisV1AwaitingDeliveryOrdersGetAwaitingDeliveryOrder(purchaseOrderUuid, opts) {
      return this.appApisV1AwaitingDeliveryOrdersGetAwaitingDeliveryOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a task bound to an awaiting delivery purchase order thanks to its UUID.
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Task} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersGetTaskWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersGetTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingDeliveryOrdersGetTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Task["default"];
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/tasks/{task_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a task bound to an awaiting delivery purchase order thanks to its UUID.
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Task}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersGetTask",
    value: function appApisV1AwaitingDeliveryOrdersGetTask(purchaseOrderUuid, taskUuid, opts) {
      return this.appApisV1AwaitingDeliveryOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a job task bound to an awaiting delivery purchase order.
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersGetTaskJobWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersGetTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingDeliveryOrdersGetTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1AwaitingDeliveryOrdersGetTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a job task bound to an awaiting delivery purchase order.
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersGetTaskJob",
    value: function appApisV1AwaitingDeliveryOrdersGetTaskJob(purchaseOrderUuid, taskUuid, jobUuid) {
      return this.appApisV1AwaitingDeliveryOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get awaiting delivery orders
     * **scope**: awaiting-delivery-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {Date} opts.receptionDate 
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1AwaitingDeliveryOrdersListAwaitingDeliveryOrders200Response} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersListAwaitingDeliveryOrdersWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersListAwaitingDeliveryOrdersWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'delivery_date': opts['deliveryDate'],
        'min_delivery_date': opts['minDeliveryDate'],
        'max_delivery_date': opts['maxDeliveryDate'],
        'ordering_date': opts['orderingDate'],
        'reception_date': opts['receptionDate'],
        'location_uuid': opts['locationUuid'],
        'deliver_uuid': opts['deliverUuid'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'order_by': opts['orderBy'],
        'descending': opts['descending'],
        'return_products': opts['returnProducts'],
        'ignore_zero_validated_quantities': opts['ignoreZeroValidatedQuantities']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AppApisV1AwaitingDeliveryOrdersListAwaitingDeliveryOrders200Response["default"];
      return this.apiClient.callApi('/awaiting-delivery-orders', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get awaiting delivery orders
     * **scope**: awaiting-delivery-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {Date} opts.receptionDate 
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1AwaitingDeliveryOrdersListAwaitingDeliveryOrders200Response}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersListAwaitingDeliveryOrders",
    value: function appApisV1AwaitingDeliveryOrdersListAwaitingDeliveryOrders(opts) {
      return this.appApisV1AwaitingDeliveryOrdersListAwaitingDeliveryOrdersWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get awaiting delivery orders
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/AwaitingDeliveryProductSchema>} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersListAwaitingDeliveryProductsWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersListAwaitingDeliveryProductsWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersListAwaitingDeliveryProducts");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'ignore_zero_validated_quantities': opts['ignoreZeroValidatedQuantities']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_AwaitingDeliveryProductSchema["default"]];
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/products', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get awaiting delivery orders
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/AwaitingDeliveryProductSchema>}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersListAwaitingDeliveryProducts",
    value: function appApisV1AwaitingDeliveryOrdersListAwaitingDeliveryProducts(purchaseOrderUuid, opts) {
      return this.appApisV1AwaitingDeliveryOrdersListAwaitingDeliveryProductsWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a list of jobs bound to an awaiting delivery purchase order task
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/JobList} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersListTaskJobsWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersListTaskJobs");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingDeliveryOrdersListTaskJobs");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _JobList["default"];
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a list of jobs bound to an awaiting delivery purchase order task
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/JobList}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersListTaskJobs",
    value: function appApisV1AwaitingDeliveryOrdersListTaskJobs(purchaseOrderUuid, taskUuid) {
      return this.appApisV1AwaitingDeliveryOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve all tasks bound to an awaiting delivery purchase order
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TaskList} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersListTasksWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersListTasks");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TaskList["default"];
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/tasks', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve all tasks bound to an awaiting delivery purchase order
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TaskList}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersListTasks",
    value: function appApisV1AwaitingDeliveryOrdersListTasks(purchaseOrderUuid, opts) {
      return this.appApisV1AwaitingDeliveryOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Change status of awaiting-delivery to delivered order
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/AwaitingDeliveryDeliverRequest} opts.awaitingDeliveryDeliverRequest The payload of the request for deliver action
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersPassAwaitingDeliveryToDeliveredWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersPassAwaitingDeliveryToDeliveredWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['awaitingDeliveryDeliverRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersPassAwaitingDeliveryToDelivered");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/deliver', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Change status of awaiting-delivery to delivered order
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/AwaitingDeliveryDeliverRequest} opts.awaitingDeliveryDeliverRequest The payload of the request for deliver action
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersPassAwaitingDeliveryToDelivered",
    value: function appApisV1AwaitingDeliveryOrdersPassAwaitingDeliveryToDelivered(purchaseOrderUuid, opts) {
      return this.appApisV1AwaitingDeliveryOrdersPassAwaitingDeliveryToDeliveredWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Change back status of awaiting-delivery to validated order
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersPassAwaitingDeliveryToValidatedWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersPassAwaitingDeliveryToValidatedWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersPassAwaitingDeliveryToValidated");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/validate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Change back status of awaiting-delivery to validated order
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersPassAwaitingDeliveryToValidated",
    value: function appApisV1AwaitingDeliveryOrdersPassAwaitingDeliveryToValidated(purchaseOrderUuid) {
      return this.appApisV1AwaitingDeliveryOrdersPassAwaitingDeliveryToValidatedWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersRunTaskWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersRunTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingDeliveryOrdersRunTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/tasks/{task_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersRunTask",
    value: function appApisV1AwaitingDeliveryOrdersRunTask(purchaseOrderUuid, taskUuid) {
      return this.appApisV1AwaitingDeliveryOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Run a job of an awaiting delivery purchase order task in a standalone mode
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersRunTaskJobWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['runPurchaseJobSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersRunTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingDeliveryOrdersRunTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1AwaitingDeliveryOrdersRunTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Run a job of an awaiting delivery purchase order task in a standalone mode
     * **scope**: awaiting-delivery-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersRunTaskJob",
    value: function appApisV1AwaitingDeliveryOrdersRunTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1AwaitingDeliveryOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Submit the output of an awaiting delivery purchase order job
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersSubmitJobOutputWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['submitPurchaseJobOutputSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersSubmitJobOutput");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingDeliveryOrdersSubmitJobOutput");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1AwaitingDeliveryOrdersSubmitJobOutput");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/submit', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Submit the output of an awaiting delivery purchase order job
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersSubmitJobOutput",
    value: function appApisV1AwaitingDeliveryOrdersSubmitJobOutput(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1AwaitingDeliveryOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update awaiting delivery order
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/AwaitingDeliveryUpdateRequest} awaitingDeliveryUpdateRequest Awaiting delivery update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AwaitingDeliveryOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrderWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrderWithHttpInfo(purchaseOrderUuid, awaitingDeliveryUpdateRequest) {
      var postBody = awaitingDeliveryUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrder");
      } // verify the required parameter 'awaitingDeliveryUpdateRequest' is set


      if (awaitingDeliveryUpdateRequest === undefined || awaitingDeliveryUpdateRequest === null) {
        throw new Error("Missing the required parameter 'awaitingDeliveryUpdateRequest' when calling appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AwaitingDeliveryOrderSchema["default"];
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update awaiting delivery order
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/AwaitingDeliveryUpdateRequest} awaitingDeliveryUpdateRequest Awaiting delivery update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AwaitingDeliveryOrderSchema}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrder",
    value: function appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrder(purchaseOrderUuid, awaitingDeliveryUpdateRequest) {
      return this.appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrderWithHttpInfo(purchaseOrderUuid, awaitingDeliveryUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update the delivery charges of an awaiting delivery purchase order
     * **scope**: awaiting-delivery-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdatePurchaseOrderDeliveryChargesRequest} opts.updatePurchaseOrderDeliveryChargesRequest The payload to send when you want to update a purchase order delivery charges
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrderDeliveryChargesWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['updatePurchaseOrderDeliveryChargesRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrderDeliveryCharges");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/update-delivery-charges', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update the delivery charges of an awaiting delivery purchase order
     * **scope**: awaiting-delivery-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdatePurchaseOrderDeliveryChargesRequest} opts.updatePurchaseOrderDeliveryChargesRequest The payload to send when you want to update a purchase order delivery charges
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrderDeliveryCharges",
    value: function appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrderDeliveryCharges(purchaseOrderUuid, opts) {
      return this.appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update awaiting delivery product
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/AwaitingDeliveryProductUpdateRequest} awaitingDeliveryProductUpdateRequest Awaiting delivery product update schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AwaitingDeliveryProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryProductWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryProductWithHttpInfo(purchaseOrderUuid, productOrderUuid, awaitingDeliveryProductUpdateRequest) {
      var postBody = awaitingDeliveryProductUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryProduct");
      } // verify the required parameter 'awaitingDeliveryProductUpdateRequest' is set


      if (awaitingDeliveryProductUpdateRequest === undefined || awaitingDeliveryProductUpdateRequest === null) {
        throw new Error("Missing the required parameter 'awaitingDeliveryProductUpdateRequest' when calling appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AwaitingDeliveryProductSchema["default"];
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update awaiting delivery product
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/AwaitingDeliveryProductUpdateRequest} awaitingDeliveryProductUpdateRequest Awaiting delivery product update schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AwaitingDeliveryProductSchema}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryProduct",
    value: function appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryProduct(purchaseOrderUuid, productOrderUuid, awaitingDeliveryProductUpdateRequest) {
      return this.appApisV1AwaitingDeliveryOrdersUpdateAwaitingDeliveryProductWithHttpInfo(purchaseOrderUuid, productOrderUuid, awaitingDeliveryProductUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a job task status bound to an awaiting delivery purchase order.
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersUpdateTaskJobWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['jobUpdateRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersUpdateTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingDeliveryOrdersUpdateTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1AwaitingDeliveryOrdersUpdateTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a job task status bound to an awaiting delivery purchase order.
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersUpdateTaskJob",
    value: function appApisV1AwaitingDeliveryOrdersUpdateTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1AwaitingDeliveryOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Upload a damage proof for a product contains in an awaiting delivery purchase order thanks to their UUIDs.
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {File} damageProof 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersUploadDamageProofWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersUploadDamageProofWithHttpInfo(purchaseOrderUuid, productOrderUuid, damageProof) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersUploadDamageProof");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1AwaitingDeliveryOrdersUploadDamageProof");
      } // verify the required parameter 'damageProof' is set


      if (damageProof === undefined || damageProof === null) {
        throw new Error("Missing the required parameter 'damageProof' when calling appApisV1AwaitingDeliveryOrdersUploadDamageProof");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {
        'damage_proof': damageProof
      };
      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/products/{product_order_uuid}/upload-proof', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Upload a damage proof for a product contains in an awaiting delivery purchase order thanks to their UUIDs.
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {File} damageProof 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersUploadDamageProof",
    value: function appApisV1AwaitingDeliveryOrdersUploadDamageProof(purchaseOrderUuid, productOrderUuid, damageProof) {
      return this.appApisV1AwaitingDeliveryOrdersUploadDamageProofWithHttpInfo(purchaseOrderUuid, productOrderUuid, damageProof).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Upload delivery note
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} deliverLabel 
     * @param {File} deliveryNotes 
     * @param {String} kitchenId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersUploadDeliveryNoteWithHttpInfo",
    value: function appApisV1AwaitingDeliveryOrdersUploadDeliveryNoteWithHttpInfo(purchaseOrderUuid, deliverLabel, deliveryNotes, kitchenId) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingDeliveryOrdersUploadDeliveryNote");
      } // verify the required parameter 'deliverLabel' is set


      if (deliverLabel === undefined || deliverLabel === null) {
        throw new Error("Missing the required parameter 'deliverLabel' when calling appApisV1AwaitingDeliveryOrdersUploadDeliveryNote");
      } // verify the required parameter 'deliveryNotes' is set


      if (deliveryNotes === undefined || deliveryNotes === null) {
        throw new Error("Missing the required parameter 'deliveryNotes' when calling appApisV1AwaitingDeliveryOrdersUploadDeliveryNote");
      } // verify the required parameter 'kitchenId' is set


      if (kitchenId === undefined || kitchenId === null) {
        throw new Error("Missing the required parameter 'kitchenId' when calling appApisV1AwaitingDeliveryOrdersUploadDeliveryNote");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {
        'deliver_label': deliverLabel,
        'delivery_notes': deliveryNotes,
        'kitchen_id': kitchenId
      };
      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_order_uuid}/upload-delivery-note', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Upload delivery note
     * **scope**: awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} deliverLabel 
     * @param {File} deliveryNotes 
     * @param {String} kitchenId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingDeliveryOrdersUploadDeliveryNote",
    value: function appApisV1AwaitingDeliveryOrdersUploadDeliveryNote(purchaseOrderUuid, deliverLabel, deliveryNotes, kitchenId) {
      return this.appApisV1AwaitingDeliveryOrdersUploadDeliveryNoteWithHttpInfo(purchaseOrderUuid, deliverLabel, deliveryNotes, kitchenId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Cancels an awaiting-validation order and updates all its validated quantities to 0.
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ValidatedOrderCancelRequest} opts.validatedOrderCancelRequest Cancellation parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersCancelAwaitingValidationOrderWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersCancelAwaitingValidationOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['validatedOrderCancelRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersCancelAwaitingValidationOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/cancel', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Cancels an awaiting-validation order and updates all its validated quantities to 0.
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ValidatedOrderCancelRequest} opts.validatedOrderCancelRequest Cancellation parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersCancelAwaitingValidationOrder",
    value: function appApisV1AwaitingValidationOrdersCancelAwaitingValidationOrder(purchaseOrderUuid, opts) {
      return this.appApisV1AwaitingValidationOrdersCancelAwaitingValidationOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Check that an awaiting validation purchase order is triggering any shipping policies
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/PurchaseOrderCheckRequest} opts.purchaseOrderCheckRequest Optional parameters sent if we want to check a purchase order shipping policies
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/TriggeredShippingPolicy>} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersCheckAwaitingValidationOrderWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersCheckAwaitingValidationOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['purchaseOrderCheckRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersCheckAwaitingValidationOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [_TriggeredShippingPolicy["default"]];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/check', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Check that an awaiting validation purchase order is triggering any shipping policies
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/PurchaseOrderCheckRequest} opts.purchaseOrderCheckRequest Optional parameters sent if we want to check a purchase order shipping policies
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/TriggeredShippingPolicy>}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersCheckAwaitingValidationOrder",
    value: function appApisV1AwaitingValidationOrdersCheckAwaitingValidationOrder(purchaseOrderUuid, opts) {
      return this.appApisV1AwaitingValidationOrdersCheckAwaitingValidationOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Add a new product substitute to an awaiting validation order
     * **scope**: awaiting-validation-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/SubstituteCreationRequest} substituteCreationRequest The information to use to create the new substitute to the awaiting delivery order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AwaitingValidationProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersCreateAwaitingValidationProductOrderWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersCreateAwaitingValidationProductOrderWithHttpInfo(purchaseOrderUuid, substituteCreationRequest) {
      var postBody = substituteCreationRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersCreateAwaitingValidationProductOrder");
      } // verify the required parameter 'substituteCreationRequest' is set


      if (substituteCreationRequest === undefined || substituteCreationRequest === null) {
        throw new Error("Missing the required parameter 'substituteCreationRequest' when calling appApisV1AwaitingValidationOrdersCreateAwaitingValidationProductOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AwaitingValidationProductSchema["default"];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/products', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Add a new product substitute to an awaiting validation order
     * **scope**: awaiting-validation-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/SubstituteCreationRequest} substituteCreationRequest The information to use to create the new substitute to the awaiting delivery order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AwaitingValidationProductSchema}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersCreateAwaitingValidationProductOrder",
    value: function appApisV1AwaitingValidationOrdersCreateAwaitingValidationProductOrder(purchaseOrderUuid, substituteCreationRequest) {
      return this.appApisV1AwaitingValidationOrdersCreateAwaitingValidationProductOrderWithHttpInfo(purchaseOrderUuid, substituteCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete Purchase Orders
     * **scope**: awaiting-validation-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersDeleteAwaitingValidationOrderWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersDeleteAwaitingValidationOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersDeleteAwaitingValidationOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete Purchase Orders
     * **scope**: awaiting-validation-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersDeleteAwaitingValidationOrder",
    value: function appApisV1AwaitingValidationOrdersDeleteAwaitingValidationOrder(purchaseOrderUuid) {
      return this.appApisV1AwaitingValidationOrdersDeleteAwaitingValidationOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get actions to do on awaiting-validation orders for a given location
     * **scope**: awaiting-validation-orders:read 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid Location uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AwaitingValidationAction} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersGetActionWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersGetActionWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'location_uuid': opts['locationUuid']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AwaitingValidationAction["default"];
      return this.apiClient.callApi('/awaiting-validation-orders/todo', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get actions to do on awaiting-validation orders for a given location
     * **scope**: awaiting-validation-orders:read 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid Location uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AwaitingValidationAction}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersGetAction",
    value: function appApisV1AwaitingValidationOrdersGetAction(opts) {
      return this.appApisV1AwaitingValidationOrdersGetActionWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get awaiting validation order
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AwaitingValidationOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersGetAwaitingValidationOrderWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersGetAwaitingValidationOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersGetAwaitingValidationOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AwaitingValidationOrderSchema["default"];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get awaiting validation order
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AwaitingValidationOrderSchema}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersGetAwaitingValidationOrder",
    value: function appApisV1AwaitingValidationOrdersGetAwaitingValidationOrder(purchaseOrderUuid) {
      return this.appApisV1AwaitingValidationOrdersGetAwaitingValidationOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a task bound to an awaiting validation purchase order thanks to its UUID.
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Task} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersGetTaskWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersGetTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingValidationOrdersGetTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Task["default"];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/tasks/{task_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a task bound to an awaiting validation purchase order thanks to its UUID.
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Task}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersGetTask",
    value: function appApisV1AwaitingValidationOrdersGetTask(purchaseOrderUuid, taskUuid, opts) {
      return this.appApisV1AwaitingValidationOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a job task bound to an awaiting validation purchase order.
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersGetTaskJobWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersGetTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingValidationOrdersGetTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1AwaitingValidationOrdersGetTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a job task bound to an awaiting validation purchase order.
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersGetTaskJob",
    value: function appApisV1AwaitingValidationOrdersGetTaskJob(purchaseOrderUuid, taskUuid, jobUuid) {
      return this.appApisV1AwaitingValidationOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get awaiting validation orders
     * **scope**: awaiting-validation-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @param {Boolean} opts.withCancelled Returns cancelled purchase orders
     * @param {Boolean} opts.withValidationOverdue Returns validation overdued purchase orders
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1AwaitingValidationOrdersListAwaitingValidationOrders200Response} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersListAwaitingValidationOrdersWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersListAwaitingValidationOrdersWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'delivery_date': opts['deliveryDate'],
        'min_delivery_date': opts['minDeliveryDate'],
        'max_delivery_date': opts['maxDeliveryDate'],
        'ordering_date': opts['orderingDate'],
        'location_uuid': opts['locationUuid'],
        'deliver_uuid': opts['deliverUuid'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'order_by': opts['orderBy'],
        'descending': opts['descending'],
        'return_products': opts['returnProducts'],
        'with_cancelled': opts['withCancelled'],
        'with_validation_overdue': opts['withValidationOverdue']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AppApisV1AwaitingValidationOrdersListAwaitingValidationOrders200Response["default"];
      return this.apiClient.callApi('/awaiting-validation-orders', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get awaiting validation orders
     * **scope**: awaiting-validation-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @param {Boolean} opts.withCancelled Returns cancelled purchase orders
     * @param {Boolean} opts.withValidationOverdue Returns validation overdued purchase orders
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1AwaitingValidationOrdersListAwaitingValidationOrders200Response}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersListAwaitingValidationOrders",
    value: function appApisV1AwaitingValidationOrdersListAwaitingValidationOrders(opts) {
      return this.appApisV1AwaitingValidationOrdersListAwaitingValidationOrdersWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get awaiting validation order products
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/AwaitingValidationProductSchema>} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersListAwaitingValidationProductsWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersListAwaitingValidationProductsWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersListAwaitingValidationProducts");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_AwaitingValidationProductSchema["default"]];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/products', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get awaiting validation order products
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/AwaitingValidationProductSchema>}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersListAwaitingValidationProducts",
    value: function appApisV1AwaitingValidationOrdersListAwaitingValidationProducts(purchaseOrderUuid) {
      return this.appApisV1AwaitingValidationOrdersListAwaitingValidationProductsWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a list of jobs bound to a purchase order task
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/JobList} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersListTaskJobsWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersListTaskJobs");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingValidationOrdersListTaskJobs");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _JobList["default"];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a list of jobs bound to a purchase order task
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/JobList}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersListTaskJobs",
    value: function appApisV1AwaitingValidationOrdersListTaskJobs(purchaseOrderUuid, taskUuid) {
      return this.appApisV1AwaitingValidationOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve all tasks bound to an awaiting validation purchase order
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TaskList} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersListTasksWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersListTasks");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TaskList["default"];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/tasks', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve all tasks bound to an awaiting validation purchase order
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TaskList}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersListTasks",
    value: function appApisV1AwaitingValidationOrdersListTasks(purchaseOrderUuid, opts) {
      return this.appApisV1AwaitingValidationOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Pass awaiting validation orders to suggested
     * **scope**: awaiting-validation-orders:write 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.draftDate Draft date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersPassAwaitingValidationOrdersToSuggestedWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersPassAwaitingValidationOrdersToSuggestedWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'delivery_date': opts['deliveryDate'],
        'min_delivery_date': opts['minDeliveryDate'],
        'max_delivery_date': opts['maxDeliveryDate'],
        'ordering_date': opts['orderingDate'],
        'draft_date': opts['draftDate'],
        'location_uuid': opts['locationUuid'],
        'deliver_uuid': opts['deliverUuid']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-validation-orders/suggest', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Pass awaiting validation orders to suggested
     * **scope**: awaiting-validation-orders:write 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.draftDate Draft date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersPassAwaitingValidationOrdersToSuggested",
    value: function appApisV1AwaitingValidationOrdersPassAwaitingValidationOrdersToSuggested(opts) {
      return this.appApisV1AwaitingValidationOrdersPassAwaitingValidationOrdersToSuggestedWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Change back status of awaiting-validation to suggested order
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersPassAwaitingValidationToSuggestedWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersPassAwaitingValidationToSuggestedWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersPassAwaitingValidationToSuggested");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/suggest', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Change back status of awaiting-validation to suggested order
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersPassAwaitingValidationToSuggested",
    value: function appApisV1AwaitingValidationOrdersPassAwaitingValidationToSuggested(purchaseOrderUuid) {
      return this.appApisV1AwaitingValidationOrdersPassAwaitingValidationToSuggestedWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Change status of awaiting-validation to validated order
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ValidatePurchaseOrderRequest} opts.validatePurchaseOrderRequest Optional parameters sent when we want to pass a purchase order to the VALIDATED state
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersPassAwaitingValidationToValidatedWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersPassAwaitingValidationToValidatedWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['validatePurchaseOrderRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersPassAwaitingValidationToValidated");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/validate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Change status of awaiting-validation to validated order
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ValidatePurchaseOrderRequest} opts.validatePurchaseOrderRequest Optional parameters sent when we want to pass a purchase order to the VALIDATED state
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersPassAwaitingValidationToValidated",
    value: function appApisV1AwaitingValidationOrdersPassAwaitingValidationToValidated(purchaseOrderUuid, opts) {
      return this.appApisV1AwaitingValidationOrdersPassAwaitingValidationToValidatedWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Reorders a purchase order in _AWAITING VALIDATION_ state which has been previously cancelled.
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersReorderAwaitingValidationOrderWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersReorderAwaitingValidationOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersReorderAwaitingValidationOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/reorder', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Reorders a purchase order in _AWAITING VALIDATION_ state which has been previously cancelled.
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersReorderAwaitingValidationOrder",
    value: function appApisV1AwaitingValidationOrdersReorderAwaitingValidationOrder(purchaseOrderUuid) {
      return this.appApisV1AwaitingValidationOrdersReorderAwaitingValidationOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersRunTaskWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersRunTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingValidationOrdersRunTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/tasks/{task_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersRunTask",
    value: function appApisV1AwaitingValidationOrdersRunTask(purchaseOrderUuid, taskUuid) {
      return this.appApisV1AwaitingValidationOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Run a job of awaiting validation purchase order task in a standalone mode
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersRunTaskJobWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['runPurchaseJobSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersRunTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingValidationOrdersRunTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1AwaitingValidationOrdersRunTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Run a job of awaiting validation purchase order task in a standalone mode
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersRunTaskJob",
    value: function appApisV1AwaitingValidationOrdersRunTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1AwaitingValidationOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Submit the output of an awaiting validation purchase order job
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersSubmitJobOutputWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['submitPurchaseJobOutputSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersSubmitJobOutput");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingValidationOrdersSubmitJobOutput");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1AwaitingValidationOrdersSubmitJobOutput");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/submit', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Submit the output of an awaiting validation purchase order job
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersSubmitJobOutput",
    value: function appApisV1AwaitingValidationOrdersSubmitJobOutput(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1AwaitingValidationOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update awaiting validation order
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/AwaitingValidationUpdateRequest} awaitingValidationUpdateRequest Awaiting validation update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AwaitingValidationOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersUpdateAwaitingValidationOrderWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersUpdateAwaitingValidationOrderWithHttpInfo(purchaseOrderUuid, awaitingValidationUpdateRequest) {
      var postBody = awaitingValidationUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersUpdateAwaitingValidationOrder");
      } // verify the required parameter 'awaitingValidationUpdateRequest' is set


      if (awaitingValidationUpdateRequest === undefined || awaitingValidationUpdateRequest === null) {
        throw new Error("Missing the required parameter 'awaitingValidationUpdateRequest' when calling appApisV1AwaitingValidationOrdersUpdateAwaitingValidationOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AwaitingValidationOrderSchema["default"];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update awaiting validation order
     * **scope**: awaiting-validation-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/AwaitingValidationUpdateRequest} awaitingValidationUpdateRequest Awaiting validation update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AwaitingValidationOrderSchema}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersUpdateAwaitingValidationOrder",
    value: function appApisV1AwaitingValidationOrdersUpdateAwaitingValidationOrder(purchaseOrderUuid, awaitingValidationUpdateRequest) {
      return this.appApisV1AwaitingValidationOrdersUpdateAwaitingValidationOrderWithHttpInfo(purchaseOrderUuid, awaitingValidationUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update awaiting validation product
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/AwaitingValidationProductUpdateRequest} awaitingValidationProductUpdateRequest Awaiting validation product update schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AwaitingValidationProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProductWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProductWithHttpInfo(purchaseOrderUuid, productOrderUuid, awaitingValidationProductUpdateRequest) {
      var postBody = awaitingValidationProductUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProduct");
      } // verify the required parameter 'awaitingValidationProductUpdateRequest' is set


      if (awaitingValidationProductUpdateRequest === undefined || awaitingValidationProductUpdateRequest === null) {
        throw new Error("Missing the required parameter 'awaitingValidationProductUpdateRequest' when calling appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AwaitingValidationProductSchema["default"];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update awaiting validation product
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/AwaitingValidationProductUpdateRequest} awaitingValidationProductUpdateRequest Awaiting validation product update schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AwaitingValidationProductSchema}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProduct",
    value: function appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProduct(purchaseOrderUuid, productOrderUuid, awaitingValidationProductUpdateRequest) {
      return this.appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProductWithHttpInfo(purchaseOrderUuid, productOrderUuid, awaitingValidationProductUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update awaiting validation order products quantities given their uuids
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Array.<module:model/AwaitingValidationOrderUpdateQuantitiesRequestInner>} awaitingValidationOrderUpdateQuantitiesRequestInner Update quantities request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProductQuantitiesWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProductQuantitiesWithHttpInfo(purchaseOrderUuid, awaitingValidationOrderUpdateQuantitiesRequestInner) {
      var postBody = awaitingValidationOrderUpdateQuantitiesRequestInner; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProductQuantities");
      } // verify the required parameter 'awaitingValidationOrderUpdateQuantitiesRequestInner' is set


      if (awaitingValidationOrderUpdateQuantitiesRequestInner === undefined || awaitingValidationOrderUpdateQuantitiesRequestInner === null) {
        throw new Error("Missing the required parameter 'awaitingValidationOrderUpdateQuantitiesRequestInner' when calling appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProductQuantities");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/update-quantities', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update awaiting validation order products quantities given their uuids
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Array.<module:model/AwaitingValidationOrderUpdateQuantitiesRequestInner>} awaitingValidationOrderUpdateQuantitiesRequestInner Update quantities request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProductQuantities",
    value: function appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProductQuantities(purchaseOrderUuid, awaitingValidationOrderUpdateQuantitiesRequestInner) {
      return this.appApisV1AwaitingValidationOrdersUpdateAwaitingValidationProductQuantitiesWithHttpInfo(purchaseOrderUuid, awaitingValidationOrderUpdateQuantitiesRequestInner).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a job task status bound to an awaiting validation purchase order.
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersUpdateTaskJobWithHttpInfo",
    value: function appApisV1AwaitingValidationOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['jobUpdateRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1AwaitingValidationOrdersUpdateTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1AwaitingValidationOrdersUpdateTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1AwaitingValidationOrdersUpdateTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a job task status bound to an awaiting validation purchase order.
     * **scope**: awaiting-validation-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1AwaitingValidationOrdersUpdateTaskJob",
    value: function appApisV1AwaitingValidationOrdersUpdateTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1AwaitingValidationOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Cancel the delivery charges of a delivered purchase order
     * **scope**: delivered-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersCancelDeliveredOrderDeliveryChargesWithHttpInfo",
    value: function appApisV1DeliveredOrdersCancelDeliveredOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersCancelDeliveredOrderDeliveryCharges");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/cancel-delivery-charges', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Cancel the delivery charges of a delivered purchase order
     * **scope**: delivered-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DeliveredOrdersCancelDeliveredOrderDeliveryCharges",
    value: function appApisV1DeliveredOrdersCancelDeliveredOrderDeliveryCharges(purchaseOrderUuid) {
      return this.appApisV1DeliveredOrdersCancelDeliveredOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete Purchase Orders
     * **scope**: delivered-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersDeleteDeliveredOrderWithHttpInfo",
    value: function appApisV1DeliveredOrdersDeleteDeliveredOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersDeleteDeliveredOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete Purchase Orders
     * **scope**: delivered-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DeliveredOrdersDeleteDeliveredOrder",
    value: function appApisV1DeliveredOrdersDeleteDeliveredOrder(purchaseOrderUuid) {
      return this.appApisV1DeliveredOrdersDeleteDeliveredOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get delivered order
     * **scope**: delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DeliveredOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersGetDeliveredOrderWithHttpInfo",
    value: function appApisV1DeliveredOrdersGetDeliveredOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersGetDeliveredOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'ignore_zero_validated_quantities': opts['ignoreZeroValidatedQuantities']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DeliveredOrderSchema["default"];
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get delivered order
     * **scope**: delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DeliveredOrderSchema}
     */

  }, {
    key: "appApisV1DeliveredOrdersGetDeliveredOrder",
    value: function appApisV1DeliveredOrdersGetDeliveredOrder(purchaseOrderUuid, opts) {
      return this.appApisV1DeliveredOrdersGetDeliveredOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a task bound to a delivered purchase order thanks to its UUID.
     * **scope**: delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Task} and HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersGetTaskWithHttpInfo",
    value: function appApisV1DeliveredOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersGetTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DeliveredOrdersGetTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Task["default"];
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/tasks/{task_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a task bound to a delivered purchase order thanks to its UUID.
     * **scope**: delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Task}
     */

  }, {
    key: "appApisV1DeliveredOrdersGetTask",
    value: function appApisV1DeliveredOrdersGetTask(purchaseOrderUuid, taskUuid, opts) {
      return this.appApisV1DeliveredOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a job task bound to a delivered purchase order.
     * **scope**: delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersGetTaskJobWithHttpInfo",
    value: function appApisV1DeliveredOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersGetTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DeliveredOrdersGetTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1DeliveredOrdersGetTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a job task bound to a delivered purchase order.
     * **scope**: delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1DeliveredOrdersGetTaskJob",
    value: function appApisV1DeliveredOrdersGetTaskJob(purchaseOrderUuid, taskUuid, jobUuid) {
      return this.appApisV1DeliveredOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get delivered orders
     * **scope**: delivered-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {Date} opts.minReceptionDate Minimum reception date
     * @param {Date} opts.maxReceptionDate Maximum reception date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @param {Boolean} opts.withIssues Returns purchase orders with damaged products or missing items
     * @param {Boolean} opts.withDamagedProducts Returns purchase orders with damaged products
     * @param {Boolean} opts.withMissingProducts Returns purchase orders with missing items
     * @param {Boolean} opts.withComments Returns purchase orders with comments
     * @param {String} opts.number Returns purchase orders with TAS-{number} format
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1DeliveredOrdersListDeliveredOrders200Response} and HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersListDeliveredOrdersWithHttpInfo",
    value: function appApisV1DeliveredOrdersListDeliveredOrdersWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'delivery_date': opts['deliveryDate'],
        'min_delivery_date': opts['minDeliveryDate'],
        'max_delivery_date': opts['maxDeliveryDate'],
        'min_reception_date': opts['minReceptionDate'],
        'max_reception_date': opts['maxReceptionDate'],
        'ordering_date': opts['orderingDate'],
        'location_uuid': opts['locationUuid'],
        'deliver_uuid': opts['deliverUuid'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'order_by': opts['orderBy'],
        'descending': opts['descending'],
        'return_products': opts['returnProducts'],
        'ignore_zero_validated_quantities': opts['ignoreZeroValidatedQuantities'],
        'with_issues': opts['withIssues'],
        'with_damaged_products': opts['withDamagedProducts'],
        'with_missing_products': opts['withMissingProducts'],
        'with_comments': opts['withComments'],
        'number': opts['number']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AppApisV1DeliveredOrdersListDeliveredOrders200Response["default"];
      return this.apiClient.callApi('/delivered-orders', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get delivered orders
     * **scope**: delivered-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {Date} opts.minReceptionDate Minimum reception date
     * @param {Date} opts.maxReceptionDate Maximum reception date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @param {Boolean} opts.withIssues Returns purchase orders with damaged products or missing items
     * @param {Boolean} opts.withDamagedProducts Returns purchase orders with damaged products
     * @param {Boolean} opts.withMissingProducts Returns purchase orders with missing items
     * @param {Boolean} opts.withComments Returns purchase orders with comments
     * @param {String} opts.number Returns purchase orders with TAS-{number} format
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1DeliveredOrdersListDeliveredOrders200Response}
     */

  }, {
    key: "appApisV1DeliveredOrdersListDeliveredOrders",
    value: function appApisV1DeliveredOrdersListDeliveredOrders(opts) {
      return this.appApisV1DeliveredOrdersListDeliveredOrdersWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get delivered order
     * **scope**: delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/DeliveredProductSchema>} and HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersListDeliveredProductsWithHttpInfo",
    value: function appApisV1DeliveredOrdersListDeliveredProductsWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersListDeliveredProducts");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'ignore_zero_validated_quantities': opts['ignoreZeroValidatedQuantities']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_DeliveredProductSchema["default"]];
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/products', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get delivered order
     * **scope**: delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/DeliveredProductSchema>}
     */

  }, {
    key: "appApisV1DeliveredOrdersListDeliveredProducts",
    value: function appApisV1DeliveredOrdersListDeliveredProducts(purchaseOrderUuid, opts) {
      return this.appApisV1DeliveredOrdersListDeliveredProductsWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a list of jobs bound to a purchase order task
     * **scope**: delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/JobList} and HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersListTaskJobsWithHttpInfo",
    value: function appApisV1DeliveredOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersListTaskJobs");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DeliveredOrdersListTaskJobs");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _JobList["default"];
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a list of jobs bound to a purchase order task
     * **scope**: delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/JobList}
     */

  }, {
    key: "appApisV1DeliveredOrdersListTaskJobs",
    value: function appApisV1DeliveredOrdersListTaskJobs(purchaseOrderUuid, taskUuid) {
      return this.appApisV1DeliveredOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve all tasks bound to a delivered purchase order
     * **scope**: delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TaskList} and HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersListTasksWithHttpInfo",
    value: function appApisV1DeliveredOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersListTasks");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TaskList["default"];
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/tasks', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve all tasks bound to a delivered purchase order
     * **scope**: delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TaskList}
     */

  }, {
    key: "appApisV1DeliveredOrdersListTasks",
    value: function appApisV1DeliveredOrdersListTasks(purchaseOrderUuid, opts) {
      return this.appApisV1DeliveredOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Change back status of delivered to awaiting-delivery order
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersPassDeliveredToAwaitingDeliveryWithHttpInfo",
    value: function appApisV1DeliveredOrdersPassDeliveredToAwaitingDeliveryWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersPassDeliveredToAwaitingDelivery");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/await-delivery', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Change back status of delivered to awaiting-delivery order
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DeliveredOrdersPassDeliveredToAwaitingDelivery",
    value: function appApisV1DeliveredOrdersPassDeliveredToAwaitingDelivery(purchaseOrderUuid) {
      return this.appApisV1DeliveredOrdersPassDeliveredToAwaitingDeliveryWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersRunTaskWithHttpInfo",
    value: function appApisV1DeliveredOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersRunTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DeliveredOrdersRunTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/tasks/{task_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DeliveredOrdersRunTask",
    value: function appApisV1DeliveredOrdersRunTask(purchaseOrderUuid, taskUuid) {
      return this.appApisV1DeliveredOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Run a job of a delivered purchase order task in a standalone mode
     * **scope**: deliverd-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersRunTaskJobWithHttpInfo",
    value: function appApisV1DeliveredOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['runPurchaseJobSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersRunTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DeliveredOrdersRunTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1DeliveredOrdersRunTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Run a job of a delivered purchase order task in a standalone mode
     * **scope**: deliverd-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DeliveredOrdersRunTaskJob",
    value: function appApisV1DeliveredOrdersRunTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1DeliveredOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get delivered orders
     * **scope**: delivered-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersSaveDraftFromDeliveredOrderWithHttpInfo",
    value: function appApisV1DeliveredOrdersSaveDraftFromDeliveredOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersSaveDraftFromDeliveredOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/save-draft-mail', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get delivered orders
     * **scope**: delivered-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DeliveredOrdersSaveDraftFromDeliveredOrder",
    value: function appApisV1DeliveredOrdersSaveDraftFromDeliveredOrder(purchaseOrderUuid) {
      return this.appApisV1DeliveredOrdersSaveDraftFromDeliveredOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Submit the output of a delivered purchase order job
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersSubmitJobOutputWithHttpInfo",
    value: function appApisV1DeliveredOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['submitPurchaseJobOutputSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersSubmitJobOutput");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DeliveredOrdersSubmitJobOutput");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1DeliveredOrdersSubmitJobOutput");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/submit', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Submit the output of a delivered purchase order job
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DeliveredOrdersSubmitJobOutput",
    value: function appApisV1DeliveredOrdersSubmitJobOutput(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1DeliveredOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update delivered order
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/DeliveredOrderUpdateRequest} deliveredOrderUpdateRequest Delivered order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DeliveredOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersUpdateDeliveredOrderWithHttpInfo",
    value: function appApisV1DeliveredOrdersUpdateDeliveredOrderWithHttpInfo(purchaseOrderUuid, deliveredOrderUpdateRequest) {
      var postBody = deliveredOrderUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersUpdateDeliveredOrder");
      } // verify the required parameter 'deliveredOrderUpdateRequest' is set


      if (deliveredOrderUpdateRequest === undefined || deliveredOrderUpdateRequest === null) {
        throw new Error("Missing the required parameter 'deliveredOrderUpdateRequest' when calling appApisV1DeliveredOrdersUpdateDeliveredOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _DeliveredOrderSchema["default"];
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update delivered order
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/DeliveredOrderUpdateRequest} deliveredOrderUpdateRequest Delivered order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DeliveredOrderSchema}
     */

  }, {
    key: "appApisV1DeliveredOrdersUpdateDeliveredOrder",
    value: function appApisV1DeliveredOrdersUpdateDeliveredOrder(purchaseOrderUuid, deliveredOrderUpdateRequest) {
      return this.appApisV1DeliveredOrdersUpdateDeliveredOrderWithHttpInfo(purchaseOrderUuid, deliveredOrderUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update the delivery charges of a delivered purchase order
     * **scope**: delivered-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdatePurchaseOrderDeliveryChargesRequest} opts.updatePurchaseOrderDeliveryChargesRequest The payload to send when you want to update a purchase order delivery charges
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersUpdateDeliveredOrderDeliveryChargesWithHttpInfo",
    value: function appApisV1DeliveredOrdersUpdateDeliveredOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['updatePurchaseOrderDeliveryChargesRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersUpdateDeliveredOrderDeliveryCharges");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/update-delivery-charges', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update the delivery charges of a delivered purchase order
     * **scope**: delivered-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdatePurchaseOrderDeliveryChargesRequest} opts.updatePurchaseOrderDeliveryChargesRequest The payload to send when you want to update a purchase order delivery charges
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DeliveredOrdersUpdateDeliveredOrderDeliveryCharges",
    value: function appApisV1DeliveredOrdersUpdateDeliveredOrderDeliveryCharges(purchaseOrderUuid, opts) {
      return this.appApisV1DeliveredOrdersUpdateDeliveredOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update delivered product order
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/DeliveredProductUpdateRequest} deliveredProductUpdateRequest Update delivered product schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DeliveredProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersUpdateDeliveredProductWithHttpInfo",
    value: function appApisV1DeliveredOrdersUpdateDeliveredProductWithHttpInfo(purchaseOrderUuid, productOrderUuid, deliveredProductUpdateRequest) {
      var postBody = deliveredProductUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersUpdateDeliveredProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1DeliveredOrdersUpdateDeliveredProduct");
      } // verify the required parameter 'deliveredProductUpdateRequest' is set


      if (deliveredProductUpdateRequest === undefined || deliveredProductUpdateRequest === null) {
        throw new Error("Missing the required parameter 'deliveredProductUpdateRequest' when calling appApisV1DeliveredOrdersUpdateDeliveredProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _DeliveredProductSchema["default"];
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update delivered product order
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/DeliveredProductUpdateRequest} deliveredProductUpdateRequest Update delivered product schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DeliveredProductSchema}
     */

  }, {
    key: "appApisV1DeliveredOrdersUpdateDeliveredProduct",
    value: function appApisV1DeliveredOrdersUpdateDeliveredProduct(purchaseOrderUuid, productOrderUuid, deliveredProductUpdateRequest) {
      return this.appApisV1DeliveredOrdersUpdateDeliveredProductWithHttpInfo(purchaseOrderUuid, productOrderUuid, deliveredProductUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update delivered product order price
     * **scope**: delivered-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/DeliveredProductPriceUpdateRequest} deliveredProductPriceUpdateRequest Update delivered product price schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersUpdateDeliveredProductPriceWithHttpInfo",
    value: function appApisV1DeliveredOrdersUpdateDeliveredProductPriceWithHttpInfo(purchaseOrderUuid, productOrderUuid, deliveredProductPriceUpdateRequest) {
      var postBody = deliveredProductPriceUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersUpdateDeliveredProductPrice");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1DeliveredOrdersUpdateDeliveredProductPrice");
      } // verify the required parameter 'deliveredProductPriceUpdateRequest' is set


      if (deliveredProductPriceUpdateRequest === undefined || deliveredProductPriceUpdateRequest === null) {
        throw new Error("Missing the required parameter 'deliveredProductPriceUpdateRequest' when calling appApisV1DeliveredOrdersUpdateDeliveredProductPrice");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/products/{product_order_uuid}/update-price', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update delivered product order price
     * **scope**: delivered-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/DeliveredProductPriceUpdateRequest} deliveredProductPriceUpdateRequest Update delivered product price schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DeliveredOrdersUpdateDeliveredProductPrice",
    value: function appApisV1DeliveredOrdersUpdateDeliveredProductPrice(purchaseOrderUuid, productOrderUuid, deliveredProductPriceUpdateRequest) {
      return this.appApisV1DeliveredOrdersUpdateDeliveredProductPriceWithHttpInfo(purchaseOrderUuid, productOrderUuid, deliveredProductPriceUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a job task status bound to a delivered purchase order.
     * **scopes**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersUpdateTaskJobWithHttpInfo",
    value: function appApisV1DeliveredOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['jobUpdateRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersUpdateTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DeliveredOrdersUpdateTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1DeliveredOrdersUpdateTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a job task status bound to a delivered purchase order.
     * **scopes**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1DeliveredOrdersUpdateTaskJob",
    value: function appApisV1DeliveredOrdersUpdateTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1DeliveredOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Upload a damage proof for a product contains in a delivered purchase order thanks to their UUIDs.
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {File} damageProof 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersUploadDamageProofWithHttpInfo",
    value: function appApisV1DeliveredOrdersUploadDamageProofWithHttpInfo(purchaseOrderUuid, productOrderUuid, damageProof) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersUploadDamageProof");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1DeliveredOrdersUploadDamageProof");
      } // verify the required parameter 'damageProof' is set


      if (damageProof === undefined || damageProof === null) {
        throw new Error("Missing the required parameter 'damageProof' when calling appApisV1DeliveredOrdersUploadDamageProof");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {
        'damage_proof': damageProof
      };
      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/products/{product_order_uuid}/upload-proof', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Upload a damage proof for a product contains in a delivered purchase order thanks to their UUIDs.
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {File} damageProof 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DeliveredOrdersUploadDamageProof",
    value: function appApisV1DeliveredOrdersUploadDamageProof(purchaseOrderUuid, productOrderUuid, damageProof) {
      return this.appApisV1DeliveredOrdersUploadDamageProofWithHttpInfo(purchaseOrderUuid, productOrderUuid, damageProof).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Upload delivery note
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} deliverLabel 
     * @param {File} deliveryNotes 
     * @param {String} kitchenId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DeliveredOrdersUploadDeliveryNoteWithHttpInfo",
    value: function appApisV1DeliveredOrdersUploadDeliveryNoteWithHttpInfo(purchaseOrderUuid, deliverLabel, deliveryNotes, kitchenId) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DeliveredOrdersUploadDeliveryNote");
      } // verify the required parameter 'deliverLabel' is set


      if (deliverLabel === undefined || deliverLabel === null) {
        throw new Error("Missing the required parameter 'deliverLabel' when calling appApisV1DeliveredOrdersUploadDeliveryNote");
      } // verify the required parameter 'deliveryNotes' is set


      if (deliveryNotes === undefined || deliveryNotes === null) {
        throw new Error("Missing the required parameter 'deliveryNotes' when calling appApisV1DeliveredOrdersUploadDeliveryNote");
      } // verify the required parameter 'kitchenId' is set


      if (kitchenId === undefined || kitchenId === null) {
        throw new Error("Missing the required parameter 'kitchenId' when calling appApisV1DeliveredOrdersUploadDeliveryNote");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {
        'deliver_label': deliverLabel,
        'delivery_notes': deliveryNotes,
        'kitchen_id': kitchenId
      };
      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/delivered-orders/{purchase_order_uuid}/upload-delivery-note', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Upload delivery note
     * **scope**: delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} deliverLabel 
     * @param {File} deliveryNotes 
     * @param {String} kitchenId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DeliveredOrdersUploadDeliveryNote",
    value: function appApisV1DeliveredOrdersUploadDeliveryNote(purchaseOrderUuid, deliverLabel, deliveryNotes, kitchenId) {
      return this.appApisV1DeliveredOrdersUploadDeliveryNoteWithHttpInfo(purchaseOrderUuid, deliverLabel, deliveryNotes, kitchenId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Cancel send Drafted order
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersCancelSendDraftedOrderWithHttpInfo",
    value: function appApisV1DraftedOrdersCancelSendDraftedOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersCancelSendDraftedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/cancel-send', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Cancel send Drafted order
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DraftedOrdersCancelSendDraftedOrder",
    value: function appApisV1DraftedOrdersCancelSendDraftedOrder(purchaseOrderUuid) {
      return this.appApisV1DraftedOrdersCancelSendDraftedOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Check that a validated purchase order is triggering any shipping policies
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/PurchaseOrderCheckRequest} opts.purchaseOrderCheckRequest Optional parameters sent if we want to check a purchase order shipping policies
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/TriggeredShippingPolicy>} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersCheckDraftedOrderWithHttpInfo",
    value: function appApisV1DraftedOrdersCheckDraftedOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['purchaseOrderCheckRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersCheckDraftedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [_TriggeredShippingPolicy["default"]];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/check', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Check that a validated purchase order is triggering any shipping policies
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/PurchaseOrderCheckRequest} opts.purchaseOrderCheckRequest Optional parameters sent if we want to check a purchase order shipping policies
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/TriggeredShippingPolicy>}
     */

  }, {
    key: "appApisV1DraftedOrdersCheckDraftedOrder",
    value: function appApisV1DraftedOrdersCheckDraftedOrder(purchaseOrderUuid, opts) {
      return this.appApisV1DraftedOrdersCheckDraftedOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Create a drafted order
     * **scope**: drafted-orders:write 
     * @param {module:model/DraftedSuggestedOrderCreationRequest} draftedSuggestedOrderCreationRequest Drafted order creation schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DraftedSuggestedOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersCreateDraftedOrderWithHttpInfo",
    value: function appApisV1DraftedOrdersCreateDraftedOrderWithHttpInfo(draftedSuggestedOrderCreationRequest) {
      var postBody = draftedSuggestedOrderCreationRequest; // verify the required parameter 'draftedSuggestedOrderCreationRequest' is set

      if (draftedSuggestedOrderCreationRequest === undefined || draftedSuggestedOrderCreationRequest === null) {
        throw new Error("Missing the required parameter 'draftedSuggestedOrderCreationRequest' when calling appApisV1DraftedOrdersCreateDraftedOrder");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _DraftedSuggestedOrderSchema["default"];
      return this.apiClient.callApi('/drafted-orders', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create a drafted order
     * **scope**: drafted-orders:write 
     * @param {module:model/DraftedSuggestedOrderCreationRequest} draftedSuggestedOrderCreationRequest Drafted order creation schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DraftedSuggestedOrderSchema}
     */

  }, {
    key: "appApisV1DraftedOrdersCreateDraftedOrder",
    value: function appApisV1DraftedOrdersCreateDraftedOrder(draftedSuggestedOrderCreationRequest) {
      return this.appApisV1DraftedOrdersCreateDraftedOrderWithHttpInfo(draftedSuggestedOrderCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * List product orders
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/DraftedSuggestedProductCreationRequest} draftedSuggestedProductCreationRequest Drafted product order creation request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DraftedSuggestedProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersCreateDraftedProductWithHttpInfo",
    value: function appApisV1DraftedOrdersCreateDraftedProductWithHttpInfo(purchaseOrderUuid, draftedSuggestedProductCreationRequest) {
      var postBody = draftedSuggestedProductCreationRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersCreateDraftedProduct");
      } // verify the required parameter 'draftedSuggestedProductCreationRequest' is set


      if (draftedSuggestedProductCreationRequest === undefined || draftedSuggestedProductCreationRequest === null) {
        throw new Error("Missing the required parameter 'draftedSuggestedProductCreationRequest' when calling appApisV1DraftedOrdersCreateDraftedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _DraftedSuggestedProductSchema["default"];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/products', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * List product orders
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/DraftedSuggestedProductCreationRequest} draftedSuggestedProductCreationRequest Drafted product order creation request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DraftedSuggestedProductSchema}
     */

  }, {
    key: "appApisV1DraftedOrdersCreateDraftedProduct",
    value: function appApisV1DraftedOrdersCreateDraftedProduct(purchaseOrderUuid, draftedSuggestedProductCreationRequest) {
      return this.appApisV1DraftedOrdersCreateDraftedProductWithHttpInfo(purchaseOrderUuid, draftedSuggestedProductCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete Purchase Orders
     * **scope**: drafted-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersDeleteDraftedOrderWithHttpInfo",
    value: function appApisV1DraftedOrdersDeleteDraftedOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersDeleteDraftedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete Purchase Orders
     * **scope**: drafted-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DraftedOrdersDeleteDraftedOrder",
    value: function appApisV1DraftedOrdersDeleteDraftedOrder(purchaseOrderUuid) {
      return this.appApisV1DraftedOrdersDeleteDraftedOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete drafted product Orders
     * **scope**: drafted-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersDeleteDraftedProductWithHttpInfo",
    value: function appApisV1DraftedOrdersDeleteDraftedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersDeleteDraftedProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1DraftedOrdersDeleteDraftedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete drafted product Orders
     * **scope**: drafted-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DraftedOrdersDeleteDraftedProduct",
    value: function appApisV1DraftedOrdersDeleteDraftedProduct(purchaseOrderUuid, productOrderUuid) {
      return this.appApisV1DraftedOrdersDeleteDraftedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Generate products orders for a given drafted order
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/DraftedSuggestedProductSchema>} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersGenerateDraftedOrderWithHttpInfo",
    value: function appApisV1DraftedOrdersGenerateDraftedOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersGenerateDraftedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_DraftedSuggestedProductSchema["default"]];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/generate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Generate products orders for a given drafted order
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/DraftedSuggestedProductSchema>}
     */

  }, {
    key: "appApisV1DraftedOrdersGenerateDraftedOrder",
    value: function appApisV1DraftedOrdersGenerateDraftedOrder(purchaseOrderUuid) {
      return this.appApisV1DraftedOrdersGenerateDraftedOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Generate all purchase orders for a location given a date
     * **scope**: drafted-orders:admin 
     * @param {module:model/DraftedSuggestedOrdersGenerationRequest} draftedSuggestedOrdersGenerationRequest Generate all drafted orders schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersGenerateDraftedOrdersWithHttpInfo",
    value: function appApisV1DraftedOrdersGenerateDraftedOrdersWithHttpInfo(draftedSuggestedOrdersGenerationRequest) {
      var postBody = draftedSuggestedOrdersGenerationRequest; // verify the required parameter 'draftedSuggestedOrdersGenerationRequest' is set

      if (draftedSuggestedOrdersGenerationRequest === undefined || draftedSuggestedOrdersGenerationRequest === null) {
        throw new Error("Missing the required parameter 'draftedSuggestedOrdersGenerationRequest' when calling appApisV1DraftedOrdersGenerateDraftedOrders");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/drafted-orders/generate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Generate all purchase orders for a location given a date
     * **scope**: drafted-orders:admin 
     * @param {module:model/DraftedSuggestedOrdersGenerationRequest} draftedSuggestedOrdersGenerationRequest Generate all drafted orders schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DraftedOrdersGenerateDraftedOrders",
    value: function appApisV1DraftedOrdersGenerateDraftedOrders(draftedSuggestedOrdersGenerationRequest) {
      return this.appApisV1DraftedOrdersGenerateDraftedOrdersWithHttpInfo(draftedSuggestedOrdersGenerationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Generate purchase order, updating price and sending event to gather quantities
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersGenerateDraftedProductWithHttpInfo",
    value: function appApisV1DraftedOrdersGenerateDraftedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersGenerateDraftedProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1DraftedOrdersGenerateDraftedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/products/{product_order_uuid}/generate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Generate purchase order, updating price and sending event to gather quantities
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DraftedOrdersGenerateDraftedProduct",
    value: function appApisV1DraftedOrdersGenerateDraftedProduct(purchaseOrderUuid, productOrderUuid) {
      return this.appApisV1DraftedOrdersGenerateDraftedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a drafted order by id
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DraftedSuggestedOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersGetDraftedOrderWithHttpInfo",
    value: function appApisV1DraftedOrdersGetDraftedOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersGetDraftedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DraftedSuggestedOrderSchema["default"];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a drafted order by id
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DraftedSuggestedOrderSchema}
     */

  }, {
    key: "appApisV1DraftedOrdersGetDraftedOrder",
    value: function appApisV1DraftedOrdersGetDraftedOrder(purchaseOrderUuid) {
      return this.appApisV1DraftedOrdersGetDraftedOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a drafted product given its uuid
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DraftedSuggestedProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersGetDraftedProductWithHttpInfo",
    value: function appApisV1DraftedOrdersGetDraftedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersGetDraftedProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1DraftedOrdersGetDraftedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DraftedSuggestedProductSchema["default"];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a drafted product given its uuid
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DraftedSuggestedProductSchema}
     */

  }, {
    key: "appApisV1DraftedOrdersGetDraftedProduct",
    value: function appApisV1DraftedOrdersGetDraftedProduct(purchaseOrderUuid, productOrderUuid) {
      return this.appApisV1DraftedOrdersGetDraftedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a task bound to a drafted purchase order thanks to its UUID.
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Task} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersGetTaskWithHttpInfo",
    value: function appApisV1DraftedOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersGetTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DraftedOrdersGetTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Task["default"];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/tasks/{task_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a task bound to a drafted purchase order thanks to its UUID.
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Task}
     */

  }, {
    key: "appApisV1DraftedOrdersGetTask",
    value: function appApisV1DraftedOrdersGetTask(purchaseOrderUuid, taskUuid, opts) {
      return this.appApisV1DraftedOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a job task bound to a drafted purchase order.
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersGetTaskJobWithHttpInfo",
    value: function appApisV1DraftedOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersGetTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DraftedOrdersGetTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1DraftedOrdersGetTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a job task bound to a drafted purchase order.
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1DraftedOrdersGetTaskJob",
    value: function appApisV1DraftedOrdersGetTaskJob(purchaseOrderUuid, taskUuid, jobUuid) {
      return this.appApisV1DraftedOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get drafted orders
     * **scope**: drafted-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {module:model/CompletionStatusEnum} opts.completionStatus 
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1DraftedOrdersListDraftedOrders200Response} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersListDraftedOrdersWithHttpInfo",
    value: function appApisV1DraftedOrdersListDraftedOrdersWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'delivery_date': opts['deliveryDate'],
        'min_delivery_date': opts['minDeliveryDate'],
        'max_delivery_date': opts['maxDeliveryDate'],
        'ordering_date': opts['orderingDate'],
        'location_uuid': opts['locationUuid'],
        'deliver_uuid': opts['deliverUuid'],
        'completion_status': opts['completionStatus'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'order_by': opts['orderBy'],
        'descending': opts['descending'],
        'return_products': opts['returnProducts']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AppApisV1DraftedOrdersListDraftedOrders200Response["default"];
      return this.apiClient.callApi('/drafted-orders', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get drafted orders
     * **scope**: drafted-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {module:model/CompletionStatusEnum} opts.completionStatus 
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1DraftedOrdersListDraftedOrders200Response}
     */

  }, {
    key: "appApisV1DraftedOrdersListDraftedOrders",
    value: function appApisV1DraftedOrdersListDraftedOrders(opts) {
      return this.appApisV1DraftedOrdersListDraftedOrdersWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * List product orders
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/DraftedSuggestedProductSchema>} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersListDraftedProductsWithHttpInfo",
    value: function appApisV1DraftedOrdersListDraftedProductsWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersListDraftedProducts");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_DraftedSuggestedProductSchema["default"]];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/products', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * List product orders
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/DraftedSuggestedProductSchema>}
     */

  }, {
    key: "appApisV1DraftedOrdersListDraftedProducts",
    value: function appApisV1DraftedOrdersListDraftedProducts(purchaseOrderUuid) {
      return this.appApisV1DraftedOrdersListDraftedProductsWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a list of jobs bound to a drafted purchase order task
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/JobList} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersListTaskJobsWithHttpInfo",
    value: function appApisV1DraftedOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersListTaskJobs");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DraftedOrdersListTaskJobs");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _JobList["default"];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a list of jobs bound to a drafted purchase order task
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/JobList}
     */

  }, {
    key: "appApisV1DraftedOrdersListTaskJobs",
    value: function appApisV1DraftedOrdersListTaskJobs(purchaseOrderUuid, taskUuid) {
      return this.appApisV1DraftedOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve all tasks bound to a drafted purchase order
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TaskList} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersListTasksWithHttpInfo",
    value: function appApisV1DraftedOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersListTasks");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TaskList["default"];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/tasks', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve all tasks bound to a drafted purchase order
     * **scope**: drafted-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TaskList}
     */

  }, {
    key: "appApisV1DraftedOrdersListTasks",
    value: function appApisV1DraftedOrdersListTasks(purchaseOrderUuid, opts) {
      return this.appApisV1DraftedOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Change status of drafted to suggested order
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersPassDraftedToSuggestedWithHttpInfo",
    value: function appApisV1DraftedOrdersPassDraftedToSuggestedWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersPassDraftedToSuggested");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/suggest', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Change status of drafted to suggested order
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DraftedOrdersPassDraftedToSuggested",
    value: function appApisV1DraftedOrdersPassDraftedToSuggested(purchaseOrderUuid) {
      return this.appApisV1DraftedOrdersPassDraftedToSuggestedWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Relaunch all drafted product orders that are still in 'IN_PROGRESS' state
     * **scope**: drafted-orders:admin 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersRelaunchInProgressDraftedProductsWithHttpInfo",
    value: function appApisV1DraftedOrdersRelaunchInProgressDraftedProductsWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/drafted-orders/products/relaunch-in-progress', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Relaunch all drafted product orders that are still in 'IN_PROGRESS' state
     * **scope**: drafted-orders:admin 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DraftedOrdersRelaunchInProgressDraftedProducts",
    value: function appApisV1DraftedOrdersRelaunchInProgressDraftedProducts() {
      return this.appApisV1DraftedOrdersRelaunchInProgressDraftedProductsWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scopes**:   - drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersRunTaskWithHttpInfo",
    value: function appApisV1DraftedOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersRunTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DraftedOrdersRunTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/tasks/{task_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scopes**:   - drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DraftedOrdersRunTask",
    value: function appApisV1DraftedOrdersRunTask(purchaseOrderUuid, taskUuid) {
      return this.appApisV1DraftedOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Run a job of a drafted purchase order task in a standalone mode
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersRunTaskJobWithHttpInfo",
    value: function appApisV1DraftedOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['runPurchaseJobSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersRunTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DraftedOrdersRunTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1DraftedOrdersRunTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Run a job of a drafted purchase order task in a standalone mode
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DraftedOrdersRunTaskJob",
    value: function appApisV1DraftedOrdersRunTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1DraftedOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Send Drafted order
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersSendDraftedOrderWithHttpInfo",
    value: function appApisV1DraftedOrdersSendDraftedOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersSendDraftedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/send', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Send Drafted order
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DraftedOrdersSendDraftedOrder",
    value: function appApisV1DraftedOrdersSendDraftedOrder(purchaseOrderUuid) {
      return this.appApisV1DraftedOrdersSendDraftedOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Submit the output of a drafted purchase order job
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersSubmitJobOutputWithHttpInfo",
    value: function appApisV1DraftedOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['submitPurchaseJobOutputSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersSubmitJobOutput");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DraftedOrdersSubmitJobOutput");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1DraftedOrdersSubmitJobOutput");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/submit', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Submit the output of a drafted purchase order job
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1DraftedOrdersSubmitJobOutput",
    value: function appApisV1DraftedOrdersSubmitJobOutput(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1DraftedOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a drafted order by id
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/DraftedSuggestedOrderUpdateRequest} draftedSuggestedOrderUpdateRequest Drafted order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DraftedSuggestedOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersUpdateDraftedOrderWithHttpInfo",
    value: function appApisV1DraftedOrdersUpdateDraftedOrderWithHttpInfo(purchaseOrderUuid, draftedSuggestedOrderUpdateRequest) {
      var postBody = draftedSuggestedOrderUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersUpdateDraftedOrder");
      } // verify the required parameter 'draftedSuggestedOrderUpdateRequest' is set


      if (draftedSuggestedOrderUpdateRequest === undefined || draftedSuggestedOrderUpdateRequest === null) {
        throw new Error("Missing the required parameter 'draftedSuggestedOrderUpdateRequest' when calling appApisV1DraftedOrdersUpdateDraftedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _DraftedSuggestedOrderSchema["default"];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a drafted order by id
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/DraftedSuggestedOrderUpdateRequest} draftedSuggestedOrderUpdateRequest Drafted order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DraftedSuggestedOrderSchema}
     */

  }, {
    key: "appApisV1DraftedOrdersUpdateDraftedOrder",
    value: function appApisV1DraftedOrdersUpdateDraftedOrder(purchaseOrderUuid, draftedSuggestedOrderUpdateRequest) {
      return this.appApisV1DraftedOrdersUpdateDraftedOrderWithHttpInfo(purchaseOrderUuid, draftedSuggestedOrderUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a drafted product order by id
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/DraftedSuggestedProductUpdateRequest} draftedSuggestedProductUpdateRequest Drafted product order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DraftedSuggestedProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersUpdateDraftedProductWithHttpInfo",
    value: function appApisV1DraftedOrdersUpdateDraftedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid, draftedSuggestedProductUpdateRequest) {
      var postBody = draftedSuggestedProductUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersUpdateDraftedProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1DraftedOrdersUpdateDraftedProduct");
      } // verify the required parameter 'draftedSuggestedProductUpdateRequest' is set


      if (draftedSuggestedProductUpdateRequest === undefined || draftedSuggestedProductUpdateRequest === null) {
        throw new Error("Missing the required parameter 'draftedSuggestedProductUpdateRequest' when calling appApisV1DraftedOrdersUpdateDraftedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _DraftedSuggestedProductSchema["default"];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a drafted product order by id
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/DraftedSuggestedProductUpdateRequest} draftedSuggestedProductUpdateRequest Drafted product order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DraftedSuggestedProductSchema}
     */

  }, {
    key: "appApisV1DraftedOrdersUpdateDraftedProduct",
    value: function appApisV1DraftedOrdersUpdateDraftedProduct(purchaseOrderUuid, productOrderUuid, draftedSuggestedProductUpdateRequest) {
      return this.appApisV1DraftedOrdersUpdateDraftedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid, draftedSuggestedProductUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a job task status bound to a drafted purchase order.
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1DraftedOrdersUpdateTaskJobWithHttpInfo",
    value: function appApisV1DraftedOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['jobUpdateRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1DraftedOrdersUpdateTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1DraftedOrdersUpdateTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1DraftedOrdersUpdateTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/drafted-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a job task status bound to a drafted purchase order.
     * **scope**: drafted-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1DraftedOrdersUpdateTaskJob",
    value: function appApisV1DraftedOrdersUpdateTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1DraftedOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Advance the reception of a purchase order.
     * **scopes**:   - purchase-orders:write   - awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.receptionDate 
     * @param {Number} opts.days 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersAdvancePurchaseOrderWithHttpInfo",
    value: function appApisV1PurchaseOrdersAdvancePurchaseOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersAdvancePurchaseOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'reception_date': opts['receptionDate'],
        'days': opts['days']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/advance', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Advance the reception of a purchase order.
     * **scopes**:   - purchase-orders:write   - awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.receptionDate 
     * @param {Number} opts.days 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1PurchaseOrdersAdvancePurchaseOrder",
    value: function appApisV1PurchaseOrdersAdvancePurchaseOrder(purchaseOrderUuid, opts) {
      return this.appApisV1PurchaseOrdersAdvancePurchaseOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Cancel the delivery charges of a purchase order
     * **scopes**:   - validated-orders:admin   - awaiting-delivery-orders:admin   - delivered-orders:admin   - purchase-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersCancelPurchaseOrderDeliveryChargesWithHttpInfo",
    value: function appApisV1PurchaseOrdersCancelPurchaseOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersCancelPurchaseOrderDeliveryCharges");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/cancel-delivery-charges', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Cancel the delivery charges of a purchase order
     * **scopes**:   - validated-orders:admin   - awaiting-delivery-orders:admin   - delivered-orders:admin   - purchase-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1PurchaseOrdersCancelPurchaseOrderDeliveryCharges",
    value: function appApisV1PurchaseOrdersCancelPurchaseOrderDeliveryCharges(purchaseOrderUuid) {
      return this.appApisV1PurchaseOrdersCancelPurchaseOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Check if a given purchase order is triggering any shipping policies
     * **scope**: purchase-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/PurchaseOrderCheckRequest} opts.purchaseOrderCheckRequest Optional parameters sent if we want to check a purchase order shipping policies
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/TriggeredShippingPolicy>} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersCheckPurchaseOrderWithHttpInfo",
    value: function appApisV1PurchaseOrdersCheckPurchaseOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['purchaseOrderCheckRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersCheckPurchaseOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [_TriggeredShippingPolicy["default"]];
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/check', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Check if a given purchase order is triggering any shipping policies
     * **scope**: purchase-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/PurchaseOrderCheckRequest} opts.purchaseOrderCheckRequest Optional parameters sent if we want to check a purchase order shipping policies
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/TriggeredShippingPolicy>}
     */

  }, {
    key: "appApisV1PurchaseOrdersCheckPurchaseOrder",
    value: function appApisV1PurchaseOrdersCheckPurchaseOrder(purchaseOrderUuid, opts) {
      return this.appApisV1PurchaseOrdersCheckPurchaseOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Create a new product order
     * **scope**: purchase-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/ProductOrderCreationRequest} productOrderCreationRequest Product order creation request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProductOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersCreateProductOrderWithHttpInfo",
    value: function appApisV1PurchaseOrdersCreateProductOrderWithHttpInfo(purchaseOrderUuid, productOrderCreationRequest) {
      var postBody = productOrderCreationRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersCreateProductOrder");
      } // verify the required parameter 'productOrderCreationRequest' is set


      if (productOrderCreationRequest === undefined || productOrderCreationRequest === null) {
        throw new Error("Missing the required parameter 'productOrderCreationRequest' when calling appApisV1PurchaseOrdersCreateProductOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProductOrderSchema["default"];
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/products', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create a new product order
     * **scope**: purchase-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/ProductOrderCreationRequest} productOrderCreationRequest Product order creation request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProductOrderSchema}
     */

  }, {
    key: "appApisV1PurchaseOrdersCreateProductOrder",
    value: function appApisV1PurchaseOrdersCreateProductOrder(purchaseOrderUuid, productOrderCreationRequest) {
      return this.appApisV1PurchaseOrdersCreateProductOrderWithHttpInfo(purchaseOrderUuid, productOrderCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Create a purchase order
     * **scope**: purchase-orders:write 
     * @param {module:model/PurchaseOrderCreationRequest} purchaseOrderCreationRequest Purchase order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PurchaseOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersCreatePurchaseOrderWithHttpInfo",
    value: function appApisV1PurchaseOrdersCreatePurchaseOrderWithHttpInfo(purchaseOrderCreationRequest) {
      var postBody = purchaseOrderCreationRequest; // verify the required parameter 'purchaseOrderCreationRequest' is set

      if (purchaseOrderCreationRequest === undefined || purchaseOrderCreationRequest === null) {
        throw new Error("Missing the required parameter 'purchaseOrderCreationRequest' when calling appApisV1PurchaseOrdersCreatePurchaseOrder");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _PurchaseOrderSchema["default"];
      return this.apiClient.callApi('/purchase-orders', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create a purchase order
     * **scope**: purchase-orders:write 
     * @param {module:model/PurchaseOrderCreationRequest} purchaseOrderCreationRequest Purchase order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PurchaseOrderSchema}
     */

  }, {
    key: "appApisV1PurchaseOrdersCreatePurchaseOrder",
    value: function appApisV1PurchaseOrdersCreatePurchaseOrder(purchaseOrderCreationRequest) {
      return this.appApisV1PurchaseOrdersCreatePurchaseOrderWithHttpInfo(purchaseOrderCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delay the reception of a purchase order.
     * **scopes**:   - purchase-orders:write   - awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.receptionDate 
     * @param {Number} opts.days 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersDelayPurchaseOrderWithHttpInfo",
    value: function appApisV1PurchaseOrdersDelayPurchaseOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersDelayPurchaseOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'reception_date': opts['receptionDate'],
        'days': opts['days']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/delay', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delay the reception of a purchase order.
     * **scopes**:   - purchase-orders:write   - awaiting-delivery-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.receptionDate 
     * @param {Number} opts.days 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1PurchaseOrdersDelayPurchaseOrder",
    value: function appApisV1PurchaseOrdersDelayPurchaseOrder(purchaseOrderUuid, opts) {
      return this.appApisV1PurchaseOrdersDelayPurchaseOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete a product order given its uuid and its purchase order uuid
     * **scope**: purchase-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersDeleteProductOrderWithHttpInfo",
    value: function appApisV1PurchaseOrdersDeleteProductOrderWithHttpInfo(purchaseOrderUuid, productOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersDeleteProductOrder");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1PurchaseOrdersDeleteProductOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete a product order given its uuid and its purchase order uuid
     * **scope**: purchase-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1PurchaseOrdersDeleteProductOrder",
    value: function appApisV1PurchaseOrdersDeleteProductOrder(purchaseOrderUuid, productOrderUuid) {
      return this.appApisV1PurchaseOrdersDeleteProductOrderWithHttpInfo(purchaseOrderUuid, productOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete Purchase Orders
     * **scope**: purchase-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersDeletePurchaseOrderWithHttpInfo",
    value: function appApisV1PurchaseOrdersDeletePurchaseOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersDeletePurchaseOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete Purchase Orders
     * **scope**: purchase-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1PurchaseOrdersDeletePurchaseOrder",
    value: function appApisV1PurchaseOrdersDeletePurchaseOrder(purchaseOrderUuid) {
      return this.appApisV1PurchaseOrdersDeletePurchaseOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Export purchase orders
     * **scope**: purchase-orders:read 
     * @param {module:model/ExportRequest} exportRequest Export request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link String} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersExportPurchaseOrdersWithHttpInfo",
    value: function appApisV1PurchaseOrdersExportPurchaseOrdersWithHttpInfo(exportRequest) {
      var postBody = exportRequest; // verify the required parameter 'exportRequest' is set

      if (exportRequest === undefined || exportRequest === null) {
        throw new Error("Missing the required parameter 'exportRequest' when calling appApisV1PurchaseOrdersExportPurchaseOrders");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['text/csv', 'application/json'];
      var returnType = 'String';
      return this.apiClient.callApi('/purchase-orders/export', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Export purchase orders
     * **scope**: purchase-orders:read 
     * @param {module:model/ExportRequest} exportRequest Export request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link String}
     */

  }, {
    key: "appApisV1PurchaseOrdersExportPurchaseOrders",
    value: function appApisV1PurchaseOrdersExportPurchaseOrders(exportRequest) {
      return this.appApisV1PurchaseOrdersExportPurchaseOrdersWithHttpInfo(exportRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a product order given its uuid and its purchase order uuid
     * **scope**: purchase-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProductOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersGetProductOrderWithHttpInfo",
    value: function appApisV1PurchaseOrdersGetProductOrderWithHttpInfo(purchaseOrderUuid, productOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersGetProductOrder");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1PurchaseOrdersGetProductOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ProductOrderSchema["default"];
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a product order given its uuid and its purchase order uuid
     * **scope**: purchase-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProductOrderSchema}
     */

  }, {
    key: "appApisV1PurchaseOrdersGetProductOrder",
    value: function appApisV1PurchaseOrdersGetProductOrder(purchaseOrderUuid, productOrderUuid) {
      return this.appApisV1PurchaseOrdersGetProductOrderWithHttpInfo(purchaseOrderUuid, productOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a purchase order by id
     * **scope**:   - purchase-orders:read   - awaiting-validation-orders:read   - validated-orders:read   - awaiting-delivery-orders:read   - delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PurchaseOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersGetPurchaseOrderWithHttpInfo",
    value: function appApisV1PurchaseOrdersGetPurchaseOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersGetPurchaseOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'ignore_zero_validated_quantities': opts['ignoreZeroValidatedQuantities']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _PurchaseOrderSchema["default"];
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a purchase order by id
     * **scope**:   - purchase-orders:read   - awaiting-validation-orders:read   - validated-orders:read   - awaiting-delivery-orders:read   - delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PurchaseOrderSchema}
     */

  }, {
    key: "appApisV1PurchaseOrdersGetPurchaseOrder",
    value: function appApisV1PurchaseOrdersGetPurchaseOrder(purchaseOrderUuid, opts) {
      return this.appApisV1PurchaseOrdersGetPurchaseOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get the purchase orders history of a given location UUIDs list
     * **scope**:   - purchase-orders:read   - awaiting-validation-orders:read   - validated-orders:read   - awaiting-delivery-orders:read   - delivered-orders:read 
     * @param {Object} opts Optional parameters
     * @param {module:model/PurchaseOrderHistoryRequest} opts.purchaseOrderHistoryRequest Purchase order history parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1PurchaseOrdersListPurchaseOrders200Response} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersGetPurchaseOrdersHistoryWithHttpInfo",
    value: function appApisV1PurchaseOrdersGetPurchaseOrdersHistoryWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['purchaseOrderHistoryRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AppApisV1PurchaseOrdersListPurchaseOrders200Response["default"];
      return this.apiClient.callApi('/purchase-orders/history', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get the purchase orders history of a given location UUIDs list
     * **scope**:   - purchase-orders:read   - awaiting-validation-orders:read   - validated-orders:read   - awaiting-delivery-orders:read   - delivered-orders:read 
     * @param {Object} opts Optional parameters
     * @param {module:model/PurchaseOrderHistoryRequest} opts.purchaseOrderHistoryRequest Purchase order history parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1PurchaseOrdersListPurchaseOrders200Response}
     */

  }, {
    key: "appApisV1PurchaseOrdersGetPurchaseOrdersHistory",
    value: function appApisV1PurchaseOrdersGetPurchaseOrdersHistory(opts) {
      return this.appApisV1PurchaseOrdersGetPurchaseOrdersHistoryWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a task bound to a purchase order thanks to its UUID.
     * **scopes**:   - purchase-orders:read   - drafted-orders:read   - suggested-orders:read   - awaiting-validation-orders:read   - validated-orders:read   - awaiting-delivery-orders:read   - delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Task} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersGetTaskWithHttpInfo",
    value: function appApisV1PurchaseOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersGetTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1PurchaseOrdersGetTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Task["default"];
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/tasks/{task_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a task bound to a purchase order thanks to its UUID.
     * **scopes**:   - purchase-orders:read   - drafted-orders:read   - suggested-orders:read   - awaiting-validation-orders:read   - validated-orders:read   - awaiting-delivery-orders:read   - delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Task}
     */

  }, {
    key: "appApisV1PurchaseOrdersGetTask",
    value: function appApisV1PurchaseOrdersGetTask(purchaseOrderUuid, taskUuid, opts) {
      return this.appApisV1PurchaseOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a job task bound to a purchase order.
     * **scopes**:   - purchase-orders:read   - drafted-orders:read   - suggested-orders:read   - awaiting-validation-orders:read   - validated-orders:read   - awaiting-delivery-orders:read   - delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersGetTaskJobWithHttpInfo",
    value: function appApisV1PurchaseOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersGetTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1PurchaseOrdersGetTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1PurchaseOrdersGetTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a job task bound to a purchase order.
     * **scopes**:   - purchase-orders:read   - drafted-orders:read   - suggested-orders:read   - awaiting-validation-orders:read   - validated-orders:read   - awaiting-delivery-orders:read   - delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1PurchaseOrdersGetTaskJob",
    value: function appApisV1PurchaseOrdersGetTaskJob(purchaseOrderUuid, taskUuid, jobUuid) {
      return this.appApisV1PurchaseOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get all purchase orders products
     * **scope**: purchase-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ProductOrderSchema>} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersListProductOrdersWithHttpInfo",
    value: function appApisV1PurchaseOrdersListProductOrdersWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersListProductOrders");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'ignore_zero_validated_quantities': opts['ignoreZeroValidatedQuantities']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_ProductOrderSchema["default"]];
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/products', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get all purchase orders products
     * **scope**: purchase-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ProductOrderSchema>}
     */

  }, {
    key: "appApisV1PurchaseOrdersListProductOrders",
    value: function appApisV1PurchaseOrdersListProductOrders(purchaseOrderUuid, opts) {
      return this.appApisV1PurchaseOrdersListProductOrdersWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get purchase orders delivers
     * **scope**: delivers:read 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid Location uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Deliver>} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersListPurchaseDeliversWithHttpInfo",
    value: function appApisV1PurchaseOrdersListPurchaseDeliversWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'location_uuid': opts['locationUuid']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_Deliver["default"]];
      return this.apiClient.callApi('/purchase-orders/delivers', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get purchase orders delivers
     * **scope**: delivers:read 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid Location uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Deliver>}
     */

  }, {
    key: "appApisV1PurchaseOrdersListPurchaseDelivers",
    value: function appApisV1PurchaseOrdersListPurchaseDelivers(opts) {
      return this.appApisV1PurchaseOrdersListPurchaseDeliversWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get purchase orders
     * **scope**: purchase-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {module:model/StatusEnum} opts.status 
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1PurchaseOrdersListPurchaseOrders200Response} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersListPurchaseOrdersWithHttpInfo",
    value: function appApisV1PurchaseOrdersListPurchaseOrdersWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'delivery_date': opts['deliveryDate'],
        'min_delivery_date': opts['minDeliveryDate'],
        'max_delivery_date': opts['maxDeliveryDate'],
        'ordering_date': opts['orderingDate'],
        'location_uuid': opts['locationUuid'],
        'deliver_uuid': opts['deliverUuid'],
        'status': opts['status'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'order_by': opts['orderBy'],
        'descending': opts['descending'],
        'return_products': opts['returnProducts']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AppApisV1PurchaseOrdersListPurchaseOrders200Response["default"];
      return this.apiClient.callApi('/purchase-orders', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get purchase orders
     * **scope**: purchase-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {module:model/StatusEnum} opts.status 
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1PurchaseOrdersListPurchaseOrders200Response}
     */

  }, {
    key: "appApisV1PurchaseOrdersListPurchaseOrders",
    value: function appApisV1PurchaseOrdersListPurchaseOrders(opts) {
      return this.appApisV1PurchaseOrdersListPurchaseOrdersWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a list of jobs bound to a purchase order task
     * **scopes**:   - purchase-orders:read   - drafted-orders:read   - suggested-orders:read   - awaiting-validation-orders:read   - validated-orders:read   - awaiting-delivery-orders:read   - delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/JobList} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersListTaskJobsWithHttpInfo",
    value: function appApisV1PurchaseOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersListTaskJobs");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1PurchaseOrdersListTaskJobs");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _JobList["default"];
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a list of jobs bound to a purchase order task
     * **scopes**:   - purchase-orders:read   - drafted-orders:read   - suggested-orders:read   - awaiting-validation-orders:read   - validated-orders:read   - awaiting-delivery-orders:read   - delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/JobList}
     */

  }, {
    key: "appApisV1PurchaseOrdersListTaskJobs",
    value: function appApisV1PurchaseOrdersListTaskJobs(purchaseOrderUuid, taskUuid) {
      return this.appApisV1PurchaseOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve all tasks bound to a purchase order
     * **scopes**:   - purchase-orders:read   - drafted-orders:read   - suggested-orders:read   - awaiting-validation-orders:read   - validated-orders:read   - awaiting-delivery-orders:read   - delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TaskList} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersListTasksWithHttpInfo",
    value: function appApisV1PurchaseOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersListTasks");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TaskList["default"];
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/tasks', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve all tasks bound to a purchase order
     * **scopes**:   - purchase-orders:read   - drafted-orders:read   - suggested-orders:read   - awaiting-validation-orders:read   - validated-orders:read   - awaiting-delivery-orders:read   - delivered-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TaskList}
     */

  }, {
    key: "appApisV1PurchaseOrdersListTasks",
    value: function appApisV1PurchaseOrdersListTasks(purchaseOrderUuid, opts) {
      return this.appApisV1PurchaseOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scopes**:   - purchase-orders:write   - drafted-orders:write   - suggested-orders:write   - awaiting-validation-orders:write   - validated-orders:write   - awaiting-delivery-orders:write   - delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersRunTaskWithHttpInfo",
    value: function appApisV1PurchaseOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersRunTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1PurchaseOrdersRunTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/tasks/{task_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scopes**:   - purchase-orders:write   - drafted-orders:write   - suggested-orders:write   - awaiting-validation-orders:write   - validated-orders:write   - awaiting-delivery-orders:write   - delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1PurchaseOrdersRunTask",
    value: function appApisV1PurchaseOrdersRunTask(purchaseOrderUuid, taskUuid) {
      return this.appApisV1PurchaseOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Run a job of purchase order task in a standalone mode
     * **scopes**:   - purchase-orders:write   - drafted-orders:write   - suggested-orders:read   - awaiting-validation-orders:write   - validated-orders:write   - awaiting-delivery-orders:write   - delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersRunTaskJobWithHttpInfo",
    value: function appApisV1PurchaseOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['runPurchaseJobSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersRunTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1PurchaseOrdersRunTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1PurchaseOrdersRunTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Run a job of purchase order task in a standalone mode
     * **scopes**:   - purchase-orders:write   - drafted-orders:write   - suggested-orders:read   - awaiting-validation-orders:write   - validated-orders:write   - awaiting-delivery-orders:write   - delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1PurchaseOrdersRunTaskJob",
    value: function appApisV1PurchaseOrdersRunTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1PurchaseOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Submit the output of a purchase order job
     * **scopes**:   - purchase-orders:write   - drafted-orders:write   - suggested-orders:write   - awaiting-validation-orders:write   - validated-orders:write   - awaiting-delivery-orders:write   - delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersSubmitJobOutputWithHttpInfo",
    value: function appApisV1PurchaseOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['submitPurchaseJobOutputSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersSubmitJobOutput");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1PurchaseOrdersSubmitJobOutput");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1PurchaseOrdersSubmitJobOutput");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/submit', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Submit the output of a purchase order job
     * **scopes**:   - purchase-orders:write   - drafted-orders:write   - suggested-orders:write   - awaiting-validation-orders:write   - validated-orders:write   - awaiting-delivery-orders:write   - delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1PurchaseOrdersSubmitJobOutput",
    value: function appApisV1PurchaseOrdersSubmitJobOutput(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1PurchaseOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Trigger existing action plans for a purchase order and start related jobs if requested
     * **scopes**:   - purchase-orders:read   - drafted-orders:write   - suggested-orders:write   - awaiting-validation-orders:write   - validated-orders:write   - awaiting-delivery-orders:write   - delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.launchJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersTriggerActionPlansWithHttpInfo",
    value: function appApisV1PurchaseOrdersTriggerActionPlansWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersTriggerActionPlans");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'launch_jobs': opts['launchJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/tasks', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Trigger existing action plans for a purchase order and start related jobs if requested
     * **scopes**:   - purchase-orders:read   - drafted-orders:write   - suggested-orders:write   - awaiting-validation-orders:write   - validated-orders:write   - awaiting-delivery-orders:write   - delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.launchJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1PurchaseOrdersTriggerActionPlans",
    value: function appApisV1PurchaseOrdersTriggerActionPlans(purchaseOrderUuid, opts) {
      return this.appApisV1PurchaseOrdersTriggerActionPlansWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update product order
     * **scope**: purchase-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/ProductOrderUpdateRequest} productOrderUpdateRequest Product order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProductOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersUpdateProductOrderWithHttpInfo",
    value: function appApisV1PurchaseOrdersUpdateProductOrderWithHttpInfo(purchaseOrderUuid, productOrderUuid, productOrderUpdateRequest) {
      var postBody = productOrderUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersUpdateProductOrder");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1PurchaseOrdersUpdateProductOrder");
      } // verify the required parameter 'productOrderUpdateRequest' is set


      if (productOrderUpdateRequest === undefined || productOrderUpdateRequest === null) {
        throw new Error("Missing the required parameter 'productOrderUpdateRequest' when calling appApisV1PurchaseOrdersUpdateProductOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProductOrderSchema["default"];
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update product order
     * **scope**: purchase-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/ProductOrderUpdateRequest} productOrderUpdateRequest Product order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProductOrderSchema}
     */

  }, {
    key: "appApisV1PurchaseOrdersUpdateProductOrder",
    value: function appApisV1PurchaseOrdersUpdateProductOrder(purchaseOrderUuid, productOrderUuid, productOrderUpdateRequest) {
      return this.appApisV1PurchaseOrdersUpdateProductOrderWithHttpInfo(purchaseOrderUuid, productOrderUuid, productOrderUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a purchase order by id
     * **scope**: purchase-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/PurchaseOrderUpdateRequest} purchaseOrderUpdateRequest Purchase order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PurchaseOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersUpdatePurchaseOrderWithHttpInfo",
    value: function appApisV1PurchaseOrdersUpdatePurchaseOrderWithHttpInfo(purchaseOrderUuid, purchaseOrderUpdateRequest) {
      var postBody = purchaseOrderUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersUpdatePurchaseOrder");
      } // verify the required parameter 'purchaseOrderUpdateRequest' is set


      if (purchaseOrderUpdateRequest === undefined || purchaseOrderUpdateRequest === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUpdateRequest' when calling appApisV1PurchaseOrdersUpdatePurchaseOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _PurchaseOrderSchema["default"];
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a purchase order by id
     * **scope**: purchase-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/PurchaseOrderUpdateRequest} purchaseOrderUpdateRequest Purchase order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PurchaseOrderSchema}
     */

  }, {
    key: "appApisV1PurchaseOrdersUpdatePurchaseOrder",
    value: function appApisV1PurchaseOrdersUpdatePurchaseOrder(purchaseOrderUuid, purchaseOrderUpdateRequest) {
      return this.appApisV1PurchaseOrdersUpdatePurchaseOrderWithHttpInfo(purchaseOrderUuid, purchaseOrderUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update the delivery charges of a purchase order
     * **scopes**:   - validated-orders:admin   - awaiting-delivery-orders:admin   - delivered-orders:admin   - purchase-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdatePurchaseOrderDeliveryChargesRequest} opts.updatePurchaseOrderDeliveryChargesRequest The payload to send when you want to update a purchase order delivery charges
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersUpdatePurchaseOrderDeliveryChargesWithHttpInfo",
    value: function appApisV1PurchaseOrdersUpdatePurchaseOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['updatePurchaseOrderDeliveryChargesRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersUpdatePurchaseOrderDeliveryCharges");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/update-delivery-charges', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update the delivery charges of a purchase order
     * **scopes**:   - validated-orders:admin   - awaiting-delivery-orders:admin   - delivered-orders:admin   - purchase-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdatePurchaseOrderDeliveryChargesRequest} opts.updatePurchaseOrderDeliveryChargesRequest The payload to send when you want to update a purchase order delivery charges
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1PurchaseOrdersUpdatePurchaseOrderDeliveryCharges",
    value: function appApisV1PurchaseOrdersUpdatePurchaseOrderDeliveryCharges(purchaseOrderUuid, opts) {
      return this.appApisV1PurchaseOrdersUpdatePurchaseOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a job task status bound to a purchase order.
     * **scopes**:  - purchase-orders:write  - drafted-orders:write  - suggested-orders:write  - awaiting-validation-orders:write  - validated-orders:write  - awaiting-delivery-orders:write  - delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersUpdateTaskJobWithHttpInfo",
    value: function appApisV1PurchaseOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['jobUpdateRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersUpdateTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1PurchaseOrdersUpdateTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1PurchaseOrdersUpdateTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a job task status bound to a purchase order.
     * **scopes**:  - purchase-orders:write  - drafted-orders:write  - suggested-orders:write  - awaiting-validation-orders:write  - validated-orders:write  - awaiting-delivery-orders:write  - delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1PurchaseOrdersUpdateTaskJob",
    value: function appApisV1PurchaseOrdersUpdateTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1PurchaseOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Upload a damage proof for a product contains in a purchase order thanks to their UUIDs.
     * **scopes**:   - purchase-orders:write   - awaiting-delivery-orders:write   - delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {File} damageProof 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1PurchaseOrdersUploadDamageProofWithHttpInfo",
    value: function appApisV1PurchaseOrdersUploadDamageProofWithHttpInfo(purchaseOrderUuid, productOrderUuid, damageProof) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1PurchaseOrdersUploadDamageProof");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1PurchaseOrdersUploadDamageProof");
      } // verify the required parameter 'damageProof' is set


      if (damageProof === undefined || damageProof === null) {
        throw new Error("Missing the required parameter 'damageProof' when calling appApisV1PurchaseOrdersUploadDamageProof");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {
        'damage_proof': damageProof
      };
      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/purchase-orders/{purchase_order_uuid}/products/{product_order_uuid}/upload-proof', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Upload a damage proof for a product contains in a purchase order thanks to their UUIDs.
     * **scopes**:   - purchase-orders:write   - awaiting-delivery-orders:write   - delivered-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {File} damageProof 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1PurchaseOrdersUploadDamageProof",
    value: function appApisV1PurchaseOrdersUploadDamageProof(purchaseOrderUuid, productOrderUuid, damageProof) {
      return this.appApisV1PurchaseOrdersUploadDamageProofWithHttpInfo(purchaseOrderUuid, productOrderUuid, damageProof).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Create a suggested order
     * **scope**: suggested-orders:write 
     * @param {module:model/DraftedSuggestedOrderCreationRequest} draftedSuggestedOrderCreationRequest Suggested order creation schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DraftedSuggestedOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersCreateSuggestedOrderWithHttpInfo",
    value: function appApisV1SuggestedOrdersCreateSuggestedOrderWithHttpInfo(draftedSuggestedOrderCreationRequest) {
      var postBody = draftedSuggestedOrderCreationRequest; // verify the required parameter 'draftedSuggestedOrderCreationRequest' is set

      if (draftedSuggestedOrderCreationRequest === undefined || draftedSuggestedOrderCreationRequest === null) {
        throw new Error("Missing the required parameter 'draftedSuggestedOrderCreationRequest' when calling appApisV1SuggestedOrdersCreateSuggestedOrder");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _DraftedSuggestedOrderSchema["default"];
      return this.apiClient.callApi('/suggested-orders', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create a suggested order
     * **scope**: suggested-orders:write 
     * @param {module:model/DraftedSuggestedOrderCreationRequest} draftedSuggestedOrderCreationRequest Suggested order creation schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DraftedSuggestedOrderSchema}
     */

  }, {
    key: "appApisV1SuggestedOrdersCreateSuggestedOrder",
    value: function appApisV1SuggestedOrdersCreateSuggestedOrder(draftedSuggestedOrderCreationRequest) {
      return this.appApisV1SuggestedOrdersCreateSuggestedOrderWithHttpInfo(draftedSuggestedOrderCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * List product orders
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/DraftedSuggestedProductCreationRequest} draftedSuggestedProductCreationRequest Drafted product order creation request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DraftedSuggestedProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersCreateSuggestedProductWithHttpInfo",
    value: function appApisV1SuggestedOrdersCreateSuggestedProductWithHttpInfo(purchaseOrderUuid, draftedSuggestedProductCreationRequest) {
      var postBody = draftedSuggestedProductCreationRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersCreateSuggestedProduct");
      } // verify the required parameter 'draftedSuggestedProductCreationRequest' is set


      if (draftedSuggestedProductCreationRequest === undefined || draftedSuggestedProductCreationRequest === null) {
        throw new Error("Missing the required parameter 'draftedSuggestedProductCreationRequest' when calling appApisV1SuggestedOrdersCreateSuggestedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _DraftedSuggestedProductSchema["default"];
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/products', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * List product orders
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/DraftedSuggestedProductCreationRequest} draftedSuggestedProductCreationRequest Drafted product order creation request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DraftedSuggestedProductSchema}
     */

  }, {
    key: "appApisV1SuggestedOrdersCreateSuggestedProduct",
    value: function appApisV1SuggestedOrdersCreateSuggestedProduct(purchaseOrderUuid, draftedSuggestedProductCreationRequest) {
      return this.appApisV1SuggestedOrdersCreateSuggestedProductWithHttpInfo(purchaseOrderUuid, draftedSuggestedProductCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete Purchase Orders
     * **scope**: suggested-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersDeleteSuggestedOrderWithHttpInfo",
    value: function appApisV1SuggestedOrdersDeleteSuggestedOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersDeleteSuggestedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete Purchase Orders
     * **scope**: suggested-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1SuggestedOrdersDeleteSuggestedOrder",
    value: function appApisV1SuggestedOrdersDeleteSuggestedOrder(purchaseOrderUuid) {
      return this.appApisV1SuggestedOrdersDeleteSuggestedOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete suggested product Orders
     * **scope**: suggested-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersDeleteSuggestedProductWithHttpInfo",
    value: function appApisV1SuggestedOrdersDeleteSuggestedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersDeleteSuggestedProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1SuggestedOrdersDeleteSuggestedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete suggested product Orders
     * **scope**: suggested-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1SuggestedOrdersDeleteSuggestedProduct",
    value: function appApisV1SuggestedOrdersDeleteSuggestedProduct(purchaseOrderUuid, productOrderUuid) {
      return this.appApisV1SuggestedOrdersDeleteSuggestedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Generate products orders for a given suggested order
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/DraftedSuggestedProductSchema>} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersGenerateSuggestedOrderWithHttpInfo",
    value: function appApisV1SuggestedOrdersGenerateSuggestedOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersGenerateSuggestedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_DraftedSuggestedProductSchema["default"]];
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/generate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Generate products orders for a given suggested order
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/DraftedSuggestedProductSchema>}
     */

  }, {
    key: "appApisV1SuggestedOrdersGenerateSuggestedOrder",
    value: function appApisV1SuggestedOrdersGenerateSuggestedOrder(purchaseOrderUuid) {
      return this.appApisV1SuggestedOrdersGenerateSuggestedOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Generate all purchase orders for a location given a date
     * **scope**: suggested-orders:admin 
     * @param {module:model/DraftedSuggestedOrdersGenerationRequest} draftedSuggestedOrdersGenerationRequest Generate all suggested order schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersGenerateSuggestedOrdersWithHttpInfo",
    value: function appApisV1SuggestedOrdersGenerateSuggestedOrdersWithHttpInfo(draftedSuggestedOrdersGenerationRequest) {
      var postBody = draftedSuggestedOrdersGenerationRequest; // verify the required parameter 'draftedSuggestedOrdersGenerationRequest' is set

      if (draftedSuggestedOrdersGenerationRequest === undefined || draftedSuggestedOrdersGenerationRequest === null) {
        throw new Error("Missing the required parameter 'draftedSuggestedOrdersGenerationRequest' when calling appApisV1SuggestedOrdersGenerateSuggestedOrders");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/suggested-orders/generate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Generate all purchase orders for a location given a date
     * **scope**: suggested-orders:admin 
     * @param {module:model/DraftedSuggestedOrdersGenerationRequest} draftedSuggestedOrdersGenerationRequest Generate all suggested order schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1SuggestedOrdersGenerateSuggestedOrders",
    value: function appApisV1SuggestedOrdersGenerateSuggestedOrders(draftedSuggestedOrdersGenerationRequest) {
      return this.appApisV1SuggestedOrdersGenerateSuggestedOrdersWithHttpInfo(draftedSuggestedOrdersGenerationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Generate purchase order, updating price and sending event to gather quantities
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersGenerateSuggestedProductWithHttpInfo",
    value: function appApisV1SuggestedOrdersGenerateSuggestedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersGenerateSuggestedProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1SuggestedOrdersGenerateSuggestedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/products/{product_order_uuid}/generate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Generate purchase order, updating price and sending event to gather quantities
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1SuggestedOrdersGenerateSuggestedProduct",
    value: function appApisV1SuggestedOrdersGenerateSuggestedProduct(purchaseOrderUuid, productOrderUuid) {
      return this.appApisV1SuggestedOrdersGenerateSuggestedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a suggested order by id
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DraftedSuggestedOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersGetSuggestedOrderWithHttpInfo",
    value: function appApisV1SuggestedOrdersGetSuggestedOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersGetSuggestedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DraftedSuggestedOrderSchema["default"];
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a suggested order by id
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DraftedSuggestedOrderSchema}
     */

  }, {
    key: "appApisV1SuggestedOrdersGetSuggestedOrder",
    value: function appApisV1SuggestedOrdersGetSuggestedOrder(purchaseOrderUuid) {
      return this.appApisV1SuggestedOrdersGetSuggestedOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a suggested product given its uuid
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DraftedSuggestedProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersGetSuggestedProductWithHttpInfo",
    value: function appApisV1SuggestedOrdersGetSuggestedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersGetSuggestedProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1SuggestedOrdersGetSuggestedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DraftedSuggestedProductSchema["default"];
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a suggested product given its uuid
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DraftedSuggestedProductSchema}
     */

  }, {
    key: "appApisV1SuggestedOrdersGetSuggestedProduct",
    value: function appApisV1SuggestedOrdersGetSuggestedProduct(purchaseOrderUuid, productOrderUuid) {
      return this.appApisV1SuggestedOrdersGetSuggestedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a task bound to a suggested purchase order thanks to its UUID.
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Task} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersGetTaskWithHttpInfo",
    value: function appApisV1SuggestedOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersGetTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1SuggestedOrdersGetTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Task["default"];
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/tasks/{task_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a task bound to a suggested purchase order thanks to its UUID.
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Task}
     */

  }, {
    key: "appApisV1SuggestedOrdersGetTask",
    value: function appApisV1SuggestedOrdersGetTask(purchaseOrderUuid, taskUuid, opts) {
      return this.appApisV1SuggestedOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a job task bound to a suggested purchase order.
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersGetTaskJobWithHttpInfo",
    value: function appApisV1SuggestedOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersGetTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1SuggestedOrdersGetTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1SuggestedOrdersGetTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a job task bound to a suggested purchase order.
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1SuggestedOrdersGetTaskJob",
    value: function appApisV1SuggestedOrdersGetTaskJob(purchaseOrderUuid, taskUuid, jobUuid) {
      return this.appApisV1SuggestedOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get suggested orders
     * **scope**: suggested-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {module:model/CompletionStatusEnum} opts.completionStatus 
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1DraftedOrdersListDraftedOrders200Response} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersListSuggestedOrdersWithHttpInfo",
    value: function appApisV1SuggestedOrdersListSuggestedOrdersWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'delivery_date': opts['deliveryDate'],
        'min_delivery_date': opts['minDeliveryDate'],
        'max_delivery_date': opts['maxDeliveryDate'],
        'ordering_date': opts['orderingDate'],
        'location_uuid': opts['locationUuid'],
        'deliver_uuid': opts['deliverUuid'],
        'completion_status': opts['completionStatus'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'order_by': opts['orderBy'],
        'descending': opts['descending'],
        'return_products': opts['returnProducts']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AppApisV1DraftedOrdersListDraftedOrders200Response["default"];
      return this.apiClient.callApi('/suggested-orders', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get suggested orders
     * **scope**: suggested-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {module:model/CompletionStatusEnum} opts.completionStatus 
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1DraftedOrdersListDraftedOrders200Response}
     */

  }, {
    key: "appApisV1SuggestedOrdersListSuggestedOrders",
    value: function appApisV1SuggestedOrdersListSuggestedOrders(opts) {
      return this.appApisV1SuggestedOrdersListSuggestedOrdersWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * List product orders
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/DraftedSuggestedProductSchema>} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersListSuggestedProductsWithHttpInfo",
    value: function appApisV1SuggestedOrdersListSuggestedProductsWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersListSuggestedProducts");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_DraftedSuggestedProductSchema["default"]];
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/products', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * List product orders
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/DraftedSuggestedProductSchema>}
     */

  }, {
    key: "appApisV1SuggestedOrdersListSuggestedProducts",
    value: function appApisV1SuggestedOrdersListSuggestedProducts(purchaseOrderUuid) {
      return this.appApisV1SuggestedOrdersListSuggestedProductsWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a list of jobs bound to a suggested purchase order task
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/JobList} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersListTaskJobsWithHttpInfo",
    value: function appApisV1SuggestedOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersListTaskJobs");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1SuggestedOrdersListTaskJobs");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _JobList["default"];
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a list of jobs bound to a suggested purchase order task
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/JobList}
     */

  }, {
    key: "appApisV1SuggestedOrdersListTaskJobs",
    value: function appApisV1SuggestedOrdersListTaskJobs(purchaseOrderUuid, taskUuid) {
      return this.appApisV1SuggestedOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve all tasks bound to a suggested purchase order
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TaskList} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersListTasksWithHttpInfo",
    value: function appApisV1SuggestedOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersListTasks");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TaskList["default"];
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/tasks', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve all tasks bound to a suggested purchase order
     * **scope**: suggested-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TaskList}
     */

  }, {
    key: "appApisV1SuggestedOrdersListTasks",
    value: function appApisV1SuggestedOrdersListTasks(purchaseOrderUuid, opts) {
      return this.appApisV1SuggestedOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Change status of all suggested order (that are complete and not manually coming from next status) to awaiting-validation order
     * **scope**: suggested-orders:write 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersPassSuggestedOrdersToAwaitingValidationWithHttpInfo",
    value: function appApisV1SuggestedOrdersPassSuggestedOrdersToAwaitingValidationWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/suggested-orders/await-validation', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Change status of all suggested order (that are complete and not manually coming from next status) to awaiting-validation order
     * **scope**: suggested-orders:write 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1SuggestedOrdersPassSuggestedOrdersToAwaitingValidation",
    value: function appApisV1SuggestedOrdersPassSuggestedOrdersToAwaitingValidation() {
      return this.appApisV1SuggestedOrdersPassSuggestedOrdersToAwaitingValidationWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Change status of suggested to awaiting-validation order
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersPassSuggestedToAwaitingValidationWithHttpInfo",
    value: function appApisV1SuggestedOrdersPassSuggestedToAwaitingValidationWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersPassSuggestedToAwaitingValidation");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/await-validation', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Change status of suggested to awaiting-validation order
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1SuggestedOrdersPassSuggestedToAwaitingValidation",
    value: function appApisV1SuggestedOrdersPassSuggestedToAwaitingValidation(purchaseOrderUuid) {
      return this.appApisV1SuggestedOrdersPassSuggestedToAwaitingValidationWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Change status of suggested to draft order
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersPassSuggestedToDraftedWithHttpInfo",
    value: function appApisV1SuggestedOrdersPassSuggestedToDraftedWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersPassSuggestedToDrafted");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/draft', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Change status of suggested to draft order
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1SuggestedOrdersPassSuggestedToDrafted",
    value: function appApisV1SuggestedOrdersPassSuggestedToDrafted(purchaseOrderUuid) {
      return this.appApisV1SuggestedOrdersPassSuggestedToDraftedWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Relaunch all suggested product orders that are still in 'IN_PROGRESS' state
     * **scope**: suggested-orders:admin 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersRelaunchInProgressSuggestedProductsWithHttpInfo",
    value: function appApisV1SuggestedOrdersRelaunchInProgressSuggestedProductsWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/suggested-orders/products/relaunch-in-progress', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Relaunch all suggested product orders that are still in 'IN_PROGRESS' state
     * **scope**: suggested-orders:admin 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1SuggestedOrdersRelaunchInProgressSuggestedProducts",
    value: function appApisV1SuggestedOrdersRelaunchInProgressSuggestedProducts() {
      return this.appApisV1SuggestedOrdersRelaunchInProgressSuggestedProductsWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersRunTaskWithHttpInfo",
    value: function appApisV1SuggestedOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersRunTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1SuggestedOrdersRunTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/tasks/{task_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1SuggestedOrdersRunTask",
    value: function appApisV1SuggestedOrdersRunTask(purchaseOrderUuid, taskUuid) {
      return this.appApisV1SuggestedOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Run a job of a suggested purchase order task in a standalone mode
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersRunTaskJobWithHttpInfo",
    value: function appApisV1SuggestedOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['runPurchaseJobSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersRunTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1SuggestedOrdersRunTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1SuggestedOrdersRunTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Run a job of a suggested purchase order task in a standalone mode
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1SuggestedOrdersRunTaskJob",
    value: function appApisV1SuggestedOrdersRunTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1SuggestedOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Submit the output of a suggested purchase order job
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersSubmitJobOutputWithHttpInfo",
    value: function appApisV1SuggestedOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['submitPurchaseJobOutputSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersSubmitJobOutput");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1SuggestedOrdersSubmitJobOutput");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1SuggestedOrdersSubmitJobOutput");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/submit', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Submit the output of a suggested purchase order job
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1SuggestedOrdersSubmitJobOutput",
    value: function appApisV1SuggestedOrdersSubmitJobOutput(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1SuggestedOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a suggested order by id
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/DraftedSuggestedOrderUpdateRequest} draftedSuggestedOrderUpdateRequest Suggested order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DraftedSuggestedOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersUpdateSuggestedOrderWithHttpInfo",
    value: function appApisV1SuggestedOrdersUpdateSuggestedOrderWithHttpInfo(purchaseOrderUuid, draftedSuggestedOrderUpdateRequest) {
      var postBody = draftedSuggestedOrderUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersUpdateSuggestedOrder");
      } // verify the required parameter 'draftedSuggestedOrderUpdateRequest' is set


      if (draftedSuggestedOrderUpdateRequest === undefined || draftedSuggestedOrderUpdateRequest === null) {
        throw new Error("Missing the required parameter 'draftedSuggestedOrderUpdateRequest' when calling appApisV1SuggestedOrdersUpdateSuggestedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _DraftedSuggestedOrderSchema["default"];
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a suggested order by id
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/DraftedSuggestedOrderUpdateRequest} draftedSuggestedOrderUpdateRequest Suggested order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DraftedSuggestedOrderSchema}
     */

  }, {
    key: "appApisV1SuggestedOrdersUpdateSuggestedOrder",
    value: function appApisV1SuggestedOrdersUpdateSuggestedOrder(purchaseOrderUuid, draftedSuggestedOrderUpdateRequest) {
      return this.appApisV1SuggestedOrdersUpdateSuggestedOrderWithHttpInfo(purchaseOrderUuid, draftedSuggestedOrderUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a suggested product order by id
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/DraftedSuggestedProductUpdateRequest} draftedSuggestedProductUpdateRequest Drafted product order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DraftedSuggestedProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersUpdateSuggestedProductWithHttpInfo",
    value: function appApisV1SuggestedOrdersUpdateSuggestedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid, draftedSuggestedProductUpdateRequest) {
      var postBody = draftedSuggestedProductUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersUpdateSuggestedProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1SuggestedOrdersUpdateSuggestedProduct");
      } // verify the required parameter 'draftedSuggestedProductUpdateRequest' is set


      if (draftedSuggestedProductUpdateRequest === undefined || draftedSuggestedProductUpdateRequest === null) {
        throw new Error("Missing the required parameter 'draftedSuggestedProductUpdateRequest' when calling appApisV1SuggestedOrdersUpdateSuggestedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _DraftedSuggestedProductSchema["default"];
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a suggested product order by id
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/DraftedSuggestedProductUpdateRequest} draftedSuggestedProductUpdateRequest Drafted product order update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DraftedSuggestedProductSchema}
     */

  }, {
    key: "appApisV1SuggestedOrdersUpdateSuggestedProduct",
    value: function appApisV1SuggestedOrdersUpdateSuggestedProduct(purchaseOrderUuid, productOrderUuid, draftedSuggestedProductUpdateRequest) {
      return this.appApisV1SuggestedOrdersUpdateSuggestedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid, draftedSuggestedProductUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a job task status bound to a purchase order.
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1SuggestedOrdersUpdateTaskJobWithHttpInfo",
    value: function appApisV1SuggestedOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['jobUpdateRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1SuggestedOrdersUpdateTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1SuggestedOrdersUpdateTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1SuggestedOrdersUpdateTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/suggested-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a job task status bound to a purchase order.
     * **scope**: suggested-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1SuggestedOrdersUpdateTaskJob",
    value: function appApisV1SuggestedOrdersUpdateTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1SuggestedOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Cancel a validated purchase order
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ValidatedOrderCancelRequest} opts.validatedOrderCancelRequest Cancellation parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersCancelValidatedOrderWithHttpInfo",
    value: function appApisV1ValidatedOrdersCancelValidatedOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['validatedOrderCancelRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersCancelValidatedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/cancel', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Cancel a validated purchase order
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ValidatedOrderCancelRequest} opts.validatedOrderCancelRequest Cancellation parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersCancelValidatedOrder",
    value: function appApisV1ValidatedOrdersCancelValidatedOrder(purchaseOrderUuid, opts) {
      return this.appApisV1ValidatedOrdersCancelValidatedOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Cancel the delivery charges of a validated purchase order
     * **scope**: validated-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersCancelValidatedOrderDeliveryChargesWithHttpInfo",
    value: function appApisV1ValidatedOrdersCancelValidatedOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersCancelValidatedOrderDeliveryCharges");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/cancel-delivery-charges', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Cancel the delivery charges of a validated purchase order
     * **scope**: validated-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersCancelValidatedOrderDeliveryCharges",
    value: function appApisV1ValidatedOrdersCancelValidatedOrderDeliveryCharges(purchaseOrderUuid) {
      return this.appApisV1ValidatedOrdersCancelValidatedOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Check that a validated purchase order is triggering any shipping policies
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/PurchaseOrderCheckRequest} opts.purchaseOrderCheckRequest Optional parameters sent if we want to check a purchase order shipping policies
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/TriggeredShippingPolicy>} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersCheckValidatedOrderWithHttpInfo",
    value: function appApisV1ValidatedOrdersCheckValidatedOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['purchaseOrderCheckRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersCheckValidatedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [_TriggeredShippingPolicy["default"]];
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/check', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Check that a validated purchase order is triggering any shipping policies
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/PurchaseOrderCheckRequest} opts.purchaseOrderCheckRequest Optional parameters sent if we want to check a purchase order shipping policies
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/TriggeredShippingPolicy>}
     */

  }, {
    key: "appApisV1ValidatedOrdersCheckValidatedOrder",
    value: function appApisV1ValidatedOrdersCheckValidatedOrder(purchaseOrderUuid, opts) {
      return this.appApisV1ValidatedOrdersCheckValidatedOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Create validated order
     * **scopes**: validated-orders:write 
     * @param {module:model/ValidatedOrderCreationRequest} validatedOrderCreationRequest Validated order creation schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ValidatedOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersCreateValidatedOrderWithHttpInfo",
    value: function appApisV1ValidatedOrdersCreateValidatedOrderWithHttpInfo(validatedOrderCreationRequest) {
      var postBody = validatedOrderCreationRequest; // verify the required parameter 'validatedOrderCreationRequest' is set

      if (validatedOrderCreationRequest === undefined || validatedOrderCreationRequest === null) {
        throw new Error("Missing the required parameter 'validatedOrderCreationRequest' when calling appApisV1ValidatedOrdersCreateValidatedOrder");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ValidatedOrderSchema["default"];
      return this.apiClient.callApi('/validated-orders', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create validated order
     * **scopes**: validated-orders:write 
     * @param {module:model/ValidatedOrderCreationRequest} validatedOrderCreationRequest Validated order creation schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ValidatedOrderSchema}
     */

  }, {
    key: "appApisV1ValidatedOrdersCreateValidatedOrder",
    value: function appApisV1ValidatedOrdersCreateValidatedOrder(validatedOrderCreationRequest) {
      return this.appApisV1ValidatedOrdersCreateValidatedOrderWithHttpInfo(validatedOrderCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Create a new validated order product
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/ValidatedProductCreationRequest} validatedProductCreationRequest Validated product creation schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ValidatedProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersCreateValidatedProductWithHttpInfo",
    value: function appApisV1ValidatedOrdersCreateValidatedProductWithHttpInfo(purchaseOrderUuid, validatedProductCreationRequest) {
      var postBody = validatedProductCreationRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersCreateValidatedProduct");
      } // verify the required parameter 'validatedProductCreationRequest' is set


      if (validatedProductCreationRequest === undefined || validatedProductCreationRequest === null) {
        throw new Error("Missing the required parameter 'validatedProductCreationRequest' when calling appApisV1ValidatedOrdersCreateValidatedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ValidatedProductSchema["default"];
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/products', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create a new validated order product
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/ValidatedProductCreationRequest} validatedProductCreationRequest Validated product creation schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ValidatedProductSchema}
     */

  }, {
    key: "appApisV1ValidatedOrdersCreateValidatedProduct",
    value: function appApisV1ValidatedOrdersCreateValidatedProduct(purchaseOrderUuid, validatedProductCreationRequest) {
      return this.appApisV1ValidatedOrdersCreateValidatedProductWithHttpInfo(purchaseOrderUuid, validatedProductCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete validated order
     * **scope**: validated-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersDeleteValidatedOrderWithHttpInfo",
    value: function appApisV1ValidatedOrdersDeleteValidatedOrderWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersDeleteValidatedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete validated order
     * **scope**: validated-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersDeleteValidatedOrder",
    value: function appApisV1ValidatedOrdersDeleteValidatedOrder(purchaseOrderUuid) {
      return this.appApisV1ValidatedOrdersDeleteValidatedOrderWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete a new validated order product
     * **scope**: validated-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersDeleteValidatedProductWithHttpInfo",
    value: function appApisV1ValidatedOrdersDeleteValidatedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersDeleteValidatedProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1ValidatedOrdersDeleteValidatedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete a new validated order product
     * **scope**: validated-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersDeleteValidatedProduct",
    value: function appApisV1ValidatedOrdersDeleteValidatedProduct(purchaseOrderUuid, productOrderUuid) {
      return this.appApisV1ValidatedOrdersDeleteValidatedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Generate a pdf for given validated purchase order
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ValidatedOrderGeneratePDFRequest} opts.validatedOrderGeneratePDFRequest PDF Creation request body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersGeneratePdfWithHttpInfo",
    value: function appApisV1ValidatedOrdersGeneratePdfWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['validatedOrderGeneratePDFRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersGeneratePdf");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/generate-pdf', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Generate a pdf for given validated purchase order
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ValidatedOrderGeneratePDFRequest} opts.validatedOrderGeneratePDFRequest PDF Creation request body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersGeneratePdf",
    value: function appApisV1ValidatedOrdersGeneratePdf(purchaseOrderUuid, opts) {
      return this.appApisV1ValidatedOrdersGeneratePdfWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Send pdf generation result for given validated purchase order
     * **scope**: validated-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ValidatedOrderSavePDFRequest} opts.validatedOrderSavePDFRequest PDF generation result request body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersGeneratePdfResultWithHttpInfo",
    value: function appApisV1ValidatedOrdersGeneratePdfResultWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['validatedOrderSavePDFRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersGeneratePdfResult");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/generate-pdf-result', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Send pdf generation result for given validated purchase order
     * **scope**: validated-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ValidatedOrderSavePDFRequest} opts.validatedOrderSavePDFRequest PDF generation result request body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersGeneratePdfResult",
    value: function appApisV1ValidatedOrdersGeneratePdfResult(purchaseOrderUuid, opts) {
      return this.appApisV1ValidatedOrdersGeneratePdfResultWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a task bound to a validated purchase order thanks to its UUID.
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Task} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersGetTaskWithHttpInfo",
    value: function appApisV1ValidatedOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersGetTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1ValidatedOrdersGetTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Task["default"];
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/tasks/{task_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a task bound to a validated purchase order thanks to its UUID.
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Task}
     */

  }, {
    key: "appApisV1ValidatedOrdersGetTask",
    value: function appApisV1ValidatedOrdersGetTask(purchaseOrderUuid, taskUuid, opts) {
      return this.appApisV1ValidatedOrdersGetTaskWithHttpInfo(purchaseOrderUuid, taskUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a job task bound to a validated purchase order.
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersGetTaskJobWithHttpInfo",
    value: function appApisV1ValidatedOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersGetTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1ValidatedOrdersGetTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1ValidatedOrdersGetTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a job task bound to a validated purchase order.
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1ValidatedOrdersGetTaskJob",
    value: function appApisV1ValidatedOrdersGetTaskJob(purchaseOrderUuid, taskUuid, jobUuid) {
      return this.appApisV1ValidatedOrdersGetTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get validated order
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ValidatedOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersGetValidatedOrderWithHttpInfo",
    value: function appApisV1ValidatedOrdersGetValidatedOrderWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersGetValidatedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'ignore_zero_validated_quantities': opts['ignoreZeroValidatedQuantities']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ValidatedOrderSchema["default"];
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get validated order
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ValidatedOrderSchema}
     */

  }, {
    key: "appApisV1ValidatedOrdersGetValidatedOrder",
    value: function appApisV1ValidatedOrdersGetValidatedOrder(purchaseOrderUuid, opts) {
      return this.appApisV1ValidatedOrdersGetValidatedOrderWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a validated product order
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ValidatedProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersGetValidatedProductWithHttpInfo",
    value: function appApisV1ValidatedOrdersGetValidatedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersGetValidatedProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1ValidatedOrdersGetValidatedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ValidatedProductSchema["default"];
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a validated product order
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ValidatedProductSchema}
     */

  }, {
    key: "appApisV1ValidatedOrdersGetValidatedProduct",
    value: function appApisV1ValidatedOrdersGetValidatedProduct(purchaseOrderUuid, productOrderUuid) {
      return this.appApisV1ValidatedOrdersGetValidatedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a list of jobs bound to a validated purchase order task
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/JobList} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersListTaskJobsWithHttpInfo",
    value: function appApisV1ValidatedOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersListTaskJobs");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1ValidatedOrdersListTaskJobs");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _JobList["default"];
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a list of jobs bound to a validated purchase order task
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/JobList}
     */

  }, {
    key: "appApisV1ValidatedOrdersListTaskJobs",
    value: function appApisV1ValidatedOrdersListTaskJobs(purchaseOrderUuid, taskUuid) {
      return this.appApisV1ValidatedOrdersListTaskJobsWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve all tasks bound to a purchase order
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TaskList} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersListTasksWithHttpInfo",
    value: function appApisV1ValidatedOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersListTasks");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_jobs': opts['withJobs']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TaskList["default"];
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/tasks', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve all tasks bound to a purchase order
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {Boolean} opts.withJobs 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TaskList}
     */

  }, {
    key: "appApisV1ValidatedOrdersListTasks",
    value: function appApisV1ValidatedOrdersListTasks(purchaseOrderUuid, opts) {
      return this.appApisV1ValidatedOrdersListTasksWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get validated orders
     * **scope**: validated-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.withCancelled Returns cancelled purchase orders
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1ValidatedOrdersListValidatedOrders200Response} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersListValidatedOrdersWithHttpInfo",
    value: function appApisV1ValidatedOrdersListValidatedOrdersWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'delivery_date': opts['deliveryDate'],
        'min_delivery_date': opts['minDeliveryDate'],
        'max_delivery_date': opts['maxDeliveryDate'],
        'ordering_date': opts['orderingDate'],
        'location_uuid': opts['locationUuid'],
        'deliver_uuid': opts['deliverUuid'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'order_by': opts['orderBy'],
        'descending': opts['descending'],
        'with_cancelled': opts['withCancelled'],
        'return_products': opts['returnProducts']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AppApisV1ValidatedOrdersListValidatedOrders200Response["default"];
      return this.apiClient.callApi('/validated-orders', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get validated orders
     * **scope**: validated-orders:read 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.deliveryDate Delivery date
     * @param {Date} opts.minDeliveryDate Minimum delivery date
     * @param {Date} opts.maxDeliveryDate Maximum delivery date
     * @param {String} opts.orderingDate Ordering date
     * @param {String} opts.locationUuid Location uuid
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @param {Boolean} opts.withCancelled Returns cancelled purchase orders
     * @param {Boolean} opts.returnProducts Also returns list of products of the purchase order
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1ValidatedOrdersListValidatedOrders200Response}
     */

  }, {
    key: "appApisV1ValidatedOrdersListValidatedOrders",
    value: function appApisV1ValidatedOrdersListValidatedOrders(opts) {
      return this.appApisV1ValidatedOrdersListValidatedOrdersWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get validated order products
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ValidatedProductSchema>} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersListValidatedProductsWithHttpInfo",
    value: function appApisV1ValidatedOrdersListValidatedProductsWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersListValidatedProducts");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {
        'ignore_zero_validated_quantities': opts['ignoreZeroValidatedQuantities']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_ValidatedProductSchema["default"]];
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/products', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get validated order products
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.ignoreZeroValidatedQuantities Ignore purchase order's products with a zero quantity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ValidatedProductSchema>}
     */

  }, {
    key: "appApisV1ValidatedOrdersListValidatedProducts",
    value: function appApisV1ValidatedOrdersListValidatedProducts(purchaseOrderUuid, opts) {
      return this.appApisV1ValidatedOrdersListValidatedProductsWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Change status of validated to awaiting-delivery order
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersPassValidatedToAwaitingDeliveryWithHttpInfo",
    value: function appApisV1ValidatedOrdersPassValidatedToAwaitingDeliveryWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersPassValidatedToAwaitingDelivery");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/await-delivery', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Change status of validated to awaiting-delivery order
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersPassValidatedToAwaitingDelivery",
    value: function appApisV1ValidatedOrdersPassValidatedToAwaitingDelivery(purchaseOrderUuid) {
      return this.appApisV1ValidatedOrdersPassValidatedToAwaitingDeliveryWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Change back status of validated to awaiting-validation order
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersPassValidatedToAwaitingValidationWithHttpInfo",
    value: function appApisV1ValidatedOrdersPassValidatedToAwaitingValidationWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersPassValidatedToAwaitingValidation");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/await-validation', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Change back status of validated to awaiting-validation order
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersPassValidatedToAwaitingValidation",
    value: function appApisV1ValidatedOrdersPassValidatedToAwaitingValidation(purchaseOrderUuid) {
      return this.appApisV1ValidatedOrdersPassValidatedToAwaitingValidationWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersRunTaskWithHttpInfo",
    value: function appApisV1ValidatedOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersRunTask");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1ValidatedOrdersRunTask");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/tasks/{task_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Clone and run an existing task into a new one. You can relaunch an old task without cloning too by specifying it in the request body. 
     * **scope**: validated-orders:read 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersRunTask",
    value: function appApisV1ValidatedOrdersRunTask(purchaseOrderUuid, taskUuid) {
      return this.appApisV1ValidatedOrdersRunTaskWithHttpInfo(purchaseOrderUuid, taskUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Run a job of a validated purchase order task in a standalone mode
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersRunTaskJobWithHttpInfo",
    value: function appApisV1ValidatedOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['runPurchaseJobSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersRunTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1ValidatedOrdersRunTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1ValidatedOrdersRunTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Run a job of a validated purchase order task in a standalone mode
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/RunPurchaseJobSchema} opts.runPurchaseJobSchema The parameters to use to run a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersRunTaskJob",
    value: function appApisV1ValidatedOrdersRunTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1ValidatedOrdersRunTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Send email to supplier for given validated purchase order
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersSendMailWithHttpInfo",
    value: function appApisV1ValidatedOrdersSendMailWithHttpInfo(purchaseOrderUuid) {
      var postBody = null; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersSendMail");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/send-mail', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Send email to supplier for given validated purchase order
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersSendMail",
    value: function appApisV1ValidatedOrdersSendMail(purchaseOrderUuid) {
      return this.appApisV1ValidatedOrdersSendMailWithHttpInfo(purchaseOrderUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Send mail result for given validated purchase order
     * **scope**: validated-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ValidatedOrderSendMailResultRequest} opts.validatedOrderSendMailResultRequest Send mail result request body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersSendMailResultWithHttpInfo",
    value: function appApisV1ValidatedOrdersSendMailResultWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['validatedOrderSendMailResultRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersSendMailResult");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/send-mail-result', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Send mail result for given validated purchase order
     * **scope**: validated-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ValidatedOrderSendMailResultRequest} opts.validatedOrderSendMailResultRequest Send mail result request body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersSendMailResult",
    value: function appApisV1ValidatedOrdersSendMailResult(purchaseOrderUuid, opts) {
      return this.appApisV1ValidatedOrdersSendMailResultWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Submit the output of a validated purchase order job
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersSubmitJobOutputWithHttpInfo",
    value: function appApisV1ValidatedOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['submitPurchaseJobOutputSchema']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersSubmitJobOutput");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1ValidatedOrdersSubmitJobOutput");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1ValidatedOrdersSubmitJobOutput");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}/submit', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Submit the output of a validated purchase order job
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SubmitPurchaseJobOutputSchema} opts.submitPurchaseJobOutputSchema The job's output to process
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersSubmitJobOutput",
    value: function appApisV1ValidatedOrdersSubmitJobOutput(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1ValidatedOrdersSubmitJobOutputWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a job task status bound to a suggested npurchase order.
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Job} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersUpdateTaskJobWithHttpInfo",
    value: function appApisV1ValidatedOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      opts = opts || {};
      var postBody = opts['jobUpdateRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersUpdateTaskJob");
      } // verify the required parameter 'taskUuid' is set


      if (taskUuid === undefined || taskUuid === null) {
        throw new Error("Missing the required parameter 'taskUuid' when calling appApisV1ValidatedOrdersUpdateTaskJob");
      } // verify the required parameter 'jobUuid' is set


      if (jobUuid === undefined || jobUuid === null) {
        throw new Error("Missing the required parameter 'jobUuid' when calling appApisV1ValidatedOrdersUpdateTaskJob");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'task_uuid': taskUuid,
        'job_uuid': jobUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Job["default"];
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/tasks/{task_uuid}/jobs/{job_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a job task status bound to a suggested npurchase order.
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} taskUuid 
     * @param {String} jobUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobUpdateRequest} opts.jobUpdateRequest The payload which is used to update a purchase order job
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Job}
     */

  }, {
    key: "appApisV1ValidatedOrdersUpdateTaskJob",
    value: function appApisV1ValidatedOrdersUpdateTaskJob(purchaseOrderUuid, taskUuid, jobUuid, opts) {
      return this.appApisV1ValidatedOrdersUpdateTaskJobWithHttpInfo(purchaseOrderUuid, taskUuid, jobUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update validated order
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/ValidatedOrderUpdateRequest} validatedOrderUpdateRequest Validated order update schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ValidatedOrderSchema} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersUpdateValidatedOrderWithHttpInfo",
    value: function appApisV1ValidatedOrdersUpdateValidatedOrderWithHttpInfo(purchaseOrderUuid, validatedOrderUpdateRequest) {
      var postBody = validatedOrderUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersUpdateValidatedOrder");
      } // verify the required parameter 'validatedOrderUpdateRequest' is set


      if (validatedOrderUpdateRequest === undefined || validatedOrderUpdateRequest === null) {
        throw new Error("Missing the required parameter 'validatedOrderUpdateRequest' when calling appApisV1ValidatedOrdersUpdateValidatedOrder");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ValidatedOrderSchema["default"];
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update validated order
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {module:model/ValidatedOrderUpdateRequest} validatedOrderUpdateRequest Validated order update schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ValidatedOrderSchema}
     */

  }, {
    key: "appApisV1ValidatedOrdersUpdateValidatedOrder",
    value: function appApisV1ValidatedOrdersUpdateValidatedOrder(purchaseOrderUuid, validatedOrderUpdateRequest) {
      return this.appApisV1ValidatedOrdersUpdateValidatedOrderWithHttpInfo(purchaseOrderUuid, validatedOrderUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update the delivery charges of a validated purchase order
     * **scope**: validated-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdatePurchaseOrderDeliveryChargesRequest} opts.updatePurchaseOrderDeliveryChargesRequest The payload to send when you want to update a purchase order delivery charges
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersUpdateValidatedOrderDeliveryChargesWithHttpInfo",
    value: function appApisV1ValidatedOrdersUpdateValidatedOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid, opts) {
      opts = opts || {};
      var postBody = opts['updatePurchaseOrderDeliveryChargesRequest']; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersUpdateValidatedOrderDeliveryCharges");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/update-delivery-charges', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update the delivery charges of a validated purchase order
     * **scope**: validated-orders:admin 
     * @param {String} purchaseOrderUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdatePurchaseOrderDeliveryChargesRequest} opts.updatePurchaseOrderDeliveryChargesRequest The payload to send when you want to update a purchase order delivery charges
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ValidatedOrdersUpdateValidatedOrderDeliveryCharges",
    value: function appApisV1ValidatedOrdersUpdateValidatedOrderDeliveryCharges(purchaseOrderUuid, opts) {
      return this.appApisV1ValidatedOrdersUpdateValidatedOrderDeliveryChargesWithHttpInfo(purchaseOrderUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a new validated order product
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/ValidatedProductUpdateRequest} validatedProductUpdateRequest Validated product update schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ValidatedProductSchema} and HTTP response
     */

  }, {
    key: "appApisV1ValidatedOrdersUpdateValidatedProductWithHttpInfo",
    value: function appApisV1ValidatedOrdersUpdateValidatedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid, validatedProductUpdateRequest) {
      var postBody = validatedProductUpdateRequest; // verify the required parameter 'purchaseOrderUuid' is set

      if (purchaseOrderUuid === undefined || purchaseOrderUuid === null) {
        throw new Error("Missing the required parameter 'purchaseOrderUuid' when calling appApisV1ValidatedOrdersUpdateValidatedProduct");
      } // verify the required parameter 'productOrderUuid' is set


      if (productOrderUuid === undefined || productOrderUuid === null) {
        throw new Error("Missing the required parameter 'productOrderUuid' when calling appApisV1ValidatedOrdersUpdateValidatedProduct");
      } // verify the required parameter 'validatedProductUpdateRequest' is set


      if (validatedProductUpdateRequest === undefined || validatedProductUpdateRequest === null) {
        throw new Error("Missing the required parameter 'validatedProductUpdateRequest' when calling appApisV1ValidatedOrdersUpdateValidatedProduct");
      }

      var pathParams = {
        'purchase_order_uuid': purchaseOrderUuid,
        'product_order_uuid': productOrderUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ValidatedProductSchema["default"];
      return this.apiClient.callApi('/validated-orders/{purchase_order_uuid}/products/{product_order_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a new validated order product
     * **scope**: validated-orders:write 
     * @param {String} purchaseOrderUuid 
     * @param {String} productOrderUuid 
     * @param {module:model/ValidatedProductUpdateRequest} validatedProductUpdateRequest Validated product update schema
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ValidatedProductSchema}
     */

  }, {
    key: "appApisV1ValidatedOrdersUpdateValidatedProduct",
    value: function appApisV1ValidatedOrdersUpdateValidatedProduct(purchaseOrderUuid, productOrderUuid, validatedProductUpdateRequest) {
      return this.appApisV1ValidatedOrdersUpdateValidatedProductWithHttpInfo(purchaseOrderUuid, productOrderUuid, validatedProductUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return PurchaseOrdersApi;
}();

exports["default"] = PurchaseOrdersApi;